var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse, _circle, _circle2, _circle3, _circle4, _path17, _ellipse2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g2, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishResult1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 629.41 350",
    style: {
      enableBackground: "new 0 0 629.41 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{opacity:0.5;fill:url(#SVGID_5_);}\n\t.st5{opacity:0.5;fill:url(#SVGID_6_);}\n\t.st6{fill:#E1E1E1;}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n\t.st10{fill:url(#SVGID_10_);}\n\t.st11{fill:url(#SVGID_11_);}\n\t.st12{fill:url(#SVGID_12_);}\n\t.st13{fill:url(#SVGID_13_);}\n\t.st14{fill:url(#SVGID_14_);}\n\t.st15{fill:url(#SVGID_15_);}\n\t.st16{opacity:0.6;fill:url(#SVGID_16_);}\n\t.st17{fill:#FFFFFF;}\n\t.st18{fill:url(#SVGID_17_);}\n\t.st19{opacity:0.6;fill:url(#SVGID_18_);}\n\t.st20{fill:url(#SVGID_19_);}\n\t.st21{fill:url(#SVGID_20_);}\n\t.st22{opacity:0.4;fill:url(#SVGID_21_);}\n\t.st23{opacity:0.2;fill:url(#SVGID_22_);}\n\t.st24{opacity:0.2;fill:url(#SVGID_23_);}\n\t.st25{opacity:0.2;fill:url(#SVGID_24_);}\n\t.st26{opacity:0.5;fill:url(#SVGID_25_);}\n\t.st27{opacity:0.5;fill:url(#SVGID_26_);}\n\t.st28{opacity:0.5;fill:url(#SVGID_27_);}\n\t.st29{fill:url(#SVGID_28_);}\n\t.st30{fill:url(#SVGID_29_);}\n\t.st31{fill:url(#SVGID_30_);}\n\t.st32{opacity:0.6;fill:url(#SVGID_31_);}\n\t.st33{fill:url(#SVGID_32_);}\n\t.st34{fill:url(#SVGID_33_);}\n\t.st35{opacity:0.5;}\n\t.st36{fill:url(#SVGID_34_);}\n\t.st37{opacity:0.4;fill:url(#SVGID_35_);}\n\t.st38{fill:url(#SVGID_36_);}\n\t.st39{opacity:0.05;fill:#FFFFFF;}\n\t.st40{opacity:0.03;fill:#FFFFFF;}\n\t.st41{opacity:0.2;fill:url(#SVGID_37_);}\n\t.st42{opacity:0.3;fill:url(#SVGID_38_);}\n\t.st43{fill:url(#SVGID_39_);}\n\t.st44{opacity:0.2;fill:url(#SVGID_40_);}\n\t.st45{opacity:0.2;fill:url(#SVGID_41_);}\n\t.st46{opacity:0.2;fill:url(#SVGID_42_);}\n\t.st47{opacity:0.2;fill:url(#SVGID_43_);}\n\t.st48{opacity:0.2;fill:url(#SVGID_44_);}\n\t.st49{opacity:0.9;}\n\t.st50{opacity:0.2;fill:url(#SVGID_45_);}\n\t.st51{opacity:0.2;fill:url(#SVGID_46_);}\n\t.st52{opacity:0.2;fill:url(#SVGID_47_);}\n\t.st53{opacity:0.2;fill:url(#SVGID_48_);}\n\t.st54{opacity:0.2;fill:url(#SVGID_49_);}\n\t.st55{fill:url(#SVGID_50_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.105,
    y1: 309.9326,
    x2: 338.5437,
    y2: 135.3725
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5126,
    style: {
      stopColor: "#78A2B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M579.96,116.88c0,0-0.87-0.28-2.52-0.7c-0.39-0.09-0.84-0.22-1.32-0.33c-0.53-0.12-1.1-0.26-1.74-0.4 c-4.12-0.9-10.4-2.05-18.39-2.78c-0.93-0.08-1.9-0.16-2.88-0.23c-0.08,0-0.16-0.02-0.22-0.02c-0.65-0.05-1.31-0.09-1.97-0.12 c-0.65-0.05-1.34-0.08-2.02-0.11c-0.65-0.03-1.31-0.06-1.99-0.09c-0.73-0.02-1.49-0.05-2.25-0.06c-0.59-0.02-1.18-0.03-1.79-0.03 c-4.57-0.08-9.48,0.03-14.69,0.37c-0.33,0.03-0.65,0.05-0.96,0.08c-0.33,0.02-0.64,0.05-0.96,0.09c-0.26,0.02-0.53,0.05-0.79,0.09 c-0.47,0.05-0.93,0.11-1.4,0.19c-0.37,0.05-0.75,0.11-1.1,0.19c-0.14,0.02-0.26,0.03-0.4,0.06c-0.37,0.06-0.76,0.14-1.14,0.22 c-0.08,0.02-0.16,0.03-0.23,0.05c-0.58,0.12-1.17,0.26-1.73,0.4c-0.06,0.02-0.11,0.03-0.17,0.05c0,0-0.03,0.02-0.08,0.03 c-0.28,0.08-0.56,0.14-0.82,0.22c-0.5,0.14-0.98,0.3-1.46,0.45c-0.73,0.22-1.45,0.47-2.15,0.75c-0.05,0.02-0.09,0.03-0.14,0.05 c-0.02,0-0.03,0.02-0.05,0.02c-0.68,0.28-1.35,0.54-2.01,0.84c-0.64,0.26-1.27,0.58-1.88,0.89c-0.09,0.05-0.2,0.09-0.3,0.16 c-0.64,0.31-1.26,0.65-1.87,1c0,0.02-0.02,0.02-0.02,0.02c-0.64,0.37-1.27,0.75-1.9,1.15c-0.05,0.03-0.09,0.06-0.16,0.09 c-0.59,0.39-1.17,0.78-1.73,1.18c-0.09,0.06-0.19,0.12-0.26,0.19c-0.23,0.19-0.48,0.36-0.72,0.53c-0.25,0.19-0.48,0.36-0.72,0.54 c-0.45,0.36-0.9,0.73-1.35,1.1c-1.34,1.12-2.61,2.3-3.84,3.56c-0.03,0.03-0.08,0.08-0.09,0.11c-0.36,0.36-0.7,0.72-1.03,1.07 c-0.42,0.44-0.84,0.89-1.21,1.35c-0.09,0.09-0.17,0.2-0.25,0.3c-0.45,0.5-0.89,1.01-1.31,1.54c-0.51,0.64-1.03,1.29-1.52,1.96 c-0.51,0.65-1,1.34-1.48,2.02c-0.48,0.65-0.93,1.32-1.38,1.99c-0.08,0.12-0.16,0.23-0.23,0.36c-0.78,1.2-1.54,2.43-2.29,3.68 c-3.25,5.46-6.06,11.35-8.63,17.34c-1.29,2.97-2.5,5.97-3.68,8.94c-0.34,0.82-0.67,1.66-1,2.49 c-10.31,26.39,2.67,47.41,26.79,70.29c0.47,0.44,0.92,0.87,1.38,1.27c23.76,21.95,63.9,18.8,63.9,18.8s-76.79,63.29-201.07,57.73 c-81.77-3.67-107.94-14.1-128.74-31.03c-20.82-16.93-57.14-63.5-61.73-70.2c-4.59-6.7-18.75-25.3-38.81-20.8 c-15.1,3.37-16.06,5.1-24.57,9.38c-3.47,1.76-11.41,1.91-11.05-6.56c0.03-0.68,0-1.49-0.06-2.43c0.03-0.25,0.06-0.37,0.06-0.37 l-0.09-0.03c-0.48-5.64-2.38-15.21-2.86-26.07c-0.44-9.97,0.3-21.01,4.37-31.07c3.17-7.87,20.46-20.45,28.22-16.57 c7.76,3.89,3.17,19.76,26.45,20.46c3.82,0.11,8.16-0.61,12.73-1.9c6.67-1.88,13.87-4.98,20.74-8.44 c17.07-8.58,32.22-19.44,32.84-19.64c0.45-0.16,16.84-11.37,42.93-24.35c36.18-17.99,91-39.37,147.77-39.32 c1.12,0,2.24,0,3.34,0.02c69.47,0.75,108.14,23.29,127.45,37.67c2.41,1.8,5.29,4.06,8.49,6.64v0.02 c6.7,5.41,14.83,12.3,23.17,19.67C576.91,114.17,578.43,115.52,579.96,116.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.6544,
    y1: 317.9276,
    x2: 373.3162,
    y2: 191.5407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5126,
    style: {
      stopColor: "#78A2B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M565.82,260.05c0,0-76.79,63.29-201.07,57.73c-81.77-3.67-107.94-14.1-128.74-31.03 c-18.35-14.91-48.71-52.83-58.8-66.22c56.35,50.73,115.77,61.85,155.19,60.51c79.26-2.68,130.38-71.58,157.85-85.09 c6.79-2.77,39.55,71.36,43.66,67.88C544.45,269.45,565.82,260.05,565.82,260.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.2254,
    y1: -48.6296,
    x2: 385.0976,
    y2: 108.8148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4167,
    style: {
      stopColor: "#78A2B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M577.44,116.18c-0.39-0.09-0.84-0.22-1.32-0.33c-0.53-0.12-1.1-0.26-1.74-0.4c-4.12-0.9-10.4-2.05-18.39-2.78 c-0.93-0.08-1.9-0.16-2.88-0.23c-0.08,0-0.16-0.02-0.22-0.02c-0.65-0.05-1.31-0.09-1.97-0.12c-0.65-0.05-1.34-0.08-2.02-0.11 c-0.65-0.03-1.31-0.06-1.99-0.09c-0.73-0.02-1.49-0.05-2.25-0.06c-0.59-0.02-1.18-0.03-1.79-0.03c-4.57-0.08-9.48,0.03-14.69,0.37 c-0.33,0.03-0.65,0.05-0.96,0.08c-0.33,0.02-0.64,0.05-0.96,0.09c-0.26,0.02-0.53,0.05-0.79,0.09c-0.47,0.05-0.93,0.11-1.4,0.19 c-0.37,0.05-0.75,0.11-1.1,0.19c-0.14,0.02-0.26,0.03-0.4,0.06c-0.37,0.06-0.76,0.14-1.14,0.22c-0.08,0.02-0.16,0.03-0.23,0.05 c-0.58,0.12-1.17,0.26-1.73,0.4c-0.06,0.02-0.11,0.03-0.17,0.05c0,0-0.03,0.02-0.08,0.03c-0.28,0.08-0.56,0.14-0.82,0.22 c-0.5,0.14-0.98,0.3-1.46,0.45c-0.73,0.23-1.45,0.48-2.15,0.75c-0.05,0.02-0.09,0.03-0.14,0.05c-0.02,0-0.03,0.02-0.05,0.02 c-0.68,0.28-1.35,0.54-2.01,0.84c-0.64,0.28-1.26,0.58-1.88,0.89c-0.09,0.05-0.2,0.09-0.3,0.16c-0.64,0.31-1.26,0.65-1.87,1 c0,0.02-0.02,0.02-0.02,0.02c-0.64,0.37-1.27,0.75-1.9,1.15c-0.05,0.03-0.09,0.06-0.16,0.09c-0.59,0.39-1.17,0.78-1.73,1.18 c-0.09,0.06-0.19,0.12-0.26,0.19c-0.23,0.19-0.48,0.36-0.72,0.53c-0.25,0.19-0.48,0.36-0.72,0.54c-0.45,0.36-0.92,0.73-1.35,1.1 c-1.34,1.12-2.61,2.3-3.84,3.56c-0.03,0.03-0.08,0.08-0.09,0.11c-0.36,0.36-0.7,0.7-1.03,1.07c-0.42,0.44-0.84,0.89-1.21,1.35 c-0.09,0.09-0.17,0.2-0.25,0.3c-0.47,0.5-0.89,1.03-1.31,1.54c-0.51,0.64-1.03,1.29-1.52,1.96c-0.51,0.65-1,1.34-1.48,2.02 c-0.48,0.65-0.93,1.32-1.38,1.99c-0.08,0.12-0.16,0.23-0.23,0.36c-0.78,1.2-1.54,2.43-2.29,3.68l-0.02-0.02 c-41.06-11.8-69-50.17-196.96-35.64c-25.2,2.86-50.42,8.55-100.66,26.87c17.07-8.58,32.22-19.44,32.84-19.64 c0.45-0.16,16.84-11.37,42.93-24.35c36.18-17.99,91-39.37,147.77-39.32c1.12,0,2.24,0,3.34,0.02 c69.47,0.75,108.14,23.29,127.45,37.67c2.41,1.8,5.29,4.06,8.49,6.64v0.02c6.7,5.41,14.83,12.3,23.17,19.67L577.44,116.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.3746,
    y1: -18.8172,
    x2: 291.9145,
    y2: 69.7088,
    gradientTransform: "matrix(1 -2.484892e-03 2.484892e-03 1 -0.3984 1.9731)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.42,0.13c0,0,7.91,5.75-1.48,10.34c0,0,1.72,11.42-6.04,11.44c0,0,6.6,10.85-4.57,12 c0,0,2.51,10.92-6.58,10.68c0,0,2.37,9.63-3.92,10.72c0,0,2.18,8.16-3.98,10.88c0,0,0.12,9.11-5.07,10.31l0.02,0.02 c0.23,0.36,3.56,5.48-2.4,9.09c0,0,3.43,4.8,0.02,8.18c0,0,0.09,0,0.25-0.02l-0.3,0.09c0,0,0.84,4.9-1.38,6.74 c0,0,15.27,0.4,22.27,6.46l0.09-0.02c17.57-10.79,59.35-34.56,109.93-48.22c0.02-0.02,0.02-0.02,0.03-0.02l0.02-0.02l0.03,0 c13.91-3.77,28.47-6.77,43.39-8.52l0.42-0.06C385.15,50.2,307,6.24,244.42,0.13z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.8877,
    y1: 35.8008,
    x2: 249.9847,
    y2: 1.4464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M385.15,50.42l-22.09,3.42c-0.06-0.03-0.12-0.08-0.19-0.12c-21.61-13.39-43.71-22.81-62.94-29.37 c-32.54-11.12-56.89-14.02-56.89-14.02C252.47,5.77,244.55,0,244.55,0c22.51,2.25,47.03,9.41,69.19,17.66 c37.16,13.82,67.71,30.69,71.1,32.59C385.05,50.36,385.15,50.42,385.15,50.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.9642,
    y1: 58.8944,
    x2: 240.0599,
    y2: 24.5394
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.09,63.65c-29.77-19.89-92.7-29.9-92.7-29.9c11.18-1.12,4.6-11.99,4.6-11.99c0,0,72.22,12.64,104.31,37.13 c0,0,0,0,0.02,0L325.09,63.65z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M628.36,220.35c-0.12-0.33-0.26-0.67-0.42-1c-0.98-2.1-4.51-4.12-9.27-5.99c1.57-2.25,6.09-9.36,5.6-15.92 C624.27,197.45,632.2,207.38,628.36,220.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M618.49,194.4c0.87-6.65-3.53-14.15-4.82-16.19c4.23-2.15,7.63-3.67,9.33-4.37c0.3-0.12,0.64-0.26,0.98-0.45 C626.24,185.66,618.49,194.4,618.49,194.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M607.79,197.1c0.67-5.16-2.04-10.87-3.67-13.74c3.16-1.83,6.23-3.48,8.99-4.87 C614.6,189.42,607.79,197.1,607.79,197.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M596.38,199.75c0.47-3.53-0.67-7.32-1.94-10.28c2.44-1.69,4.98-3.31,7.48-4.8 C601.76,193.68,596.38,199.75,596.38,199.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M585.4,204.19c0.3-2.29-0.06-4.66-0.72-6.87c1.82-1.74,3.84-3.45,5.99-5.1 C589.57,199.5,585.4,204.19,585.4,204.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M617.82,213.04c-3.11-1.15-6.67-2.24-10.36-3.23c2.05-2.67,6.47-9.13,6.41-15.41 C613.87,194.4,619.43,202.44,617.82,213.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M605.99,209.42c-3.28-0.86-6.62-1.63-9.78-2.32c1.51-1.68,6.7-7.91,6.92-14.2 C603.12,192.91,607.68,200.15,605.99,209.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M595.71,207.01c-2.85-0.62-5.54-1.17-7.9-1.62c2.01-2.43,5.05-6.81,5.33-11.29 C593.14,194.1,596.42,199.65,595.71,207.01z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.1595,
    y1: 338.1976,
    x2: 213.941,
    y2: 247.9312
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M267.94,304.32c0,0,0,0-0.02,0.02c-0.81,0.34-24.46,10.28-60.33,12.28c-10.95,0.61-23.03,0.48-35.95-0.89 c0,0,4.38-3.5,7.29-8.68c1.66-2.95,2.86-6.45,2.49-10.15c-0.03-0.33-0.08-0.64-0.14-0.95c-1.23-6.67-7.84-8.82-9.98-9.3 c-0.36-0.09-0.59-0.12-0.65-0.12c0.25,0,2.47-5.74,3.45-11.07c0.28-1.41,0.45-2.8,0.48-4.04c0.06-2.22,0.02-4.35-0.12-6.37 c-0.25-3.96-0.86-7.54-1.74-10.82c-1.06-3.89-2.49-7.32-4.21-10.42c-0.81-1.48-1.68-2.86-2.61-4.18c-1.54-2.21-3.13-4.17-4.71-5.95 c-3.44-3.92-6.76-6.98-9.19-9.89c-0.53-0.61-1.01-1.21-1.43-1.82c-1.96-2.75-2.92-5.46-2.19-8.77c0.09-0.42,0.22-0.87,0.37-1.32 c3.39-9.92,3.96-14.44,3.96-14.44l0.22-0.02c6.86,2.92,12.38,8.04,16.28,12.53c2.25,2.57,3.95,4.94,5.08,6.59 c0.5,0.72,1.35,1.91,2.52,3.47c1.9,2.52,4.59,6,7.85,10.12c2.39,3.03,5.1,6.41,8.04,9.97c2.63,3.23,5.43,6.61,8.33,10.04 c2.78,3.3,5.66,6.62,8.55,9.89c3,3.41,6.02,6.73,8.99,9.9c3.28,3.5,6.5,6.79,9.55,9.73c2.8,2.69,5.46,5.08,7.9,7.07 c1,0.81,1.99,1.6,3.02,2.38c4.24,3.23,8.78,6.2,14.02,8.91C257.46,300.31,262.32,302.41,267.94,304.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.7227,
    y1: 247.0156,
    x2: 183.7117,
    y2: 274.2448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M267.94,304.32c0,0,0,0-0.02,0.02c-0.81,0.34-24.46,10.28-60.33,12.28c-15.04-21.43-21.66-56.28-33.07-75.66 c-6.58-11.15-16.09-15.53-23.96-19c-2.21-3.11-3.16-6.17-1.82-10.09c3.39-9.92,3.96-14.44,3.96-14.44l0.22-0.02 c10.76,4.59,18.25,14.58,21.36,19.12c4.59,6.7,40.91,53.27,61.73,70.2C244.58,293.72,254.05,299.58,267.94,304.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.4206,
    y1: 376.0465,
    x2: 341.9417,
    y2: 317.8376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M373.6,318.06c-3.72,4.46-10.68,11.86-20.45,18.32c-11.8,7.79-35.22,11.79-53.11,13.62 c0,0,5.74-24.08,25.45-34.89c11.46,1.1,24.44,1.99,39.26,2.66C367.74,317.89,370.7,318,373.6,318.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.2924,
    y1: 302.7537,
    x2: 335.9425,
    y2: 340.2032
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M373.6,318.06c-3.72,4.46-10.68,11.86-20.45,18.32c-11.8,7.79-35.22,11.79-53.11,13.62 c0,0,5.74-24.08,25.45-34.89c11.46,1.1,24.44,1.99,39.26,2.66C367.74,317.89,370.7,318,373.6,318.06z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -11.9592,
    y1: 175.0507,
    x2: 115.5718,
    y2: 166.5839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M131.95,196.56c-1.35,1.17-23.12,20.29-32.09,37.36c-9.28,17.62-34.16,69.97-57.22,75.67 c-23.07,5.69-35.76,3.96-35.76,3.96s0.26-6.39,1.01-13.56c0.28-2.75,0.62-5.63,1.06-8.29c0.39-2.36,0.87-4.06,1.41-5.35 c1.65-3.98,3.76-4.17,4.54-7.87c1.04-4.93-5.18-7.53-6.47-8.04c-0.95-0.37-6.73-6.83-8.13-17.1c-0.47-3.39-0.45-7.2,0.39-11.33 v-0.02c0.12-0.7,0.3-1.4,0.48-2.13c1.63-6.23,5.85-14.69,10.73-23.2c2.6-4.52,5.38-9.05,8.05-13.28 c6.73-10.62,12.81-19.25,13.67-20.77c1.06-1.91,0.93-3.84,1.35-5.99c0.28-1.51,0.82-3.13,2.22-4.91c0.79-1.03,3.48-2.89,6.06-5.66 c3.72-4.03,7.21-9.95,4.29-17.93c-0.92-2.52-2.38-5.77-4.06-9.58c-1.96-4.43-4.23-9.61-6.28-15.22 c-2.89-7.88-5.38-16.62-6.03-25.37c-0.33-4.2-0.23-8.4,0.45-12.5c0.26-1.71,0.65-3.41,1.13-5.07c1.24-4.26,1.85-8.68,1.76-13.12 c-0.03-1.68,0.08-3.56,0.44-5.54c0.23-1.41,0.62-2.88,1.18-4.35c0.86-2.21,1.51-4.48,1.88-6.79c0.68-3.75,0.68-7.59-0.11-11.37 c-0.5-2.32-1.23-4.94-2.25-7.88c0,0,47.3,20.27,93.83,90.66c-3.41-1.69-8.64-0.23-13.73,2.63c-3.65,2.05-7.21,4.82-9.95,7.62 c-1.77,1.8-3.19,3.64-4.06,5.3c-0.19,0.36-0.34,0.7-0.48,1.03c-1.6,3.95-2.67,8.05-3.37,12.17c-0.37,2.16-0.64,4.32-0.81,6.48 c-0.19,2.22-0.28,4.42-0.28,6.59c-0.03,2.8,0.06,5.55,0.23,8.21c0.02,0.31,0.03,0.61,0.06,0.92v0.02c0.06,1,0.14,1.97,0.23,2.94 c0.34,3.81,0.81,7.37,1.24,10.54c0.2,1.41,0.39,2.75,0.56,4v0.02c0.3,2.18,0.53,4.09,0.65,5.66c0.06,0.93,0.09,1.74,0.06,2.43 c-0.11,2.67,0.61,4.49,1.74,5.66c0.23,0.25,0.47,0.45,0.73,0.64c2.53,1.83,6.42,1.35,8.58,0.26c6.67-3.36,8.71-5.13,16.56-7.37 l0.05-0.02C128.81,197.35,130.29,196.96,131.95,196.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.3967,
    y1: 182.4407,
    x2: 40.4386,
    y2: 179.4226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M131.95,196.56c-1.35,1.17-23.12,20.29-32.09,37.36c-5.88,11.13-17.97,36.16-31.92,54.51 c-6.23-17.1-23.01-30.72-8.66-55.57c19.54-33.82,9.78-65.33,8.85-112.63c-0.5-24.92,11.05-39.29,22.09-47.31 c12.38,12.67,25.86,28.8,39.27,49.09c-7.76-3.87-25.05,8.71-28.22,16.57c-8.61,21.32-2.29,46.97-1.48,57.54 c0.06,0.93,0.09,1.74,0.06,2.43c-0.36,8.47,7.59,8.32,11.05,6.56C118.71,201.19,120.17,199.42,131.95,196.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 532.571,
    y1: 254.3075,
    x2: 581.192,
    y2: 110.9062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4EDE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4874,
    style: {
      stopColor: "#5D8898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M628.75,228.95c-1.37,4.4-5.19,8.19-10.49,11.02c-5.95,3.19-33.91,16.53-51.59,24.94 c-10.08,4.79-21.85,4.63-31.72-0.54c-1.46-0.78-3-1.6-4.59-2.5c-3.89-2.19-8.1-4.79-12.44-7.81c-5.69-3.95-11.63-8.63-17.38-14.09 c-24.12-22.89-37.1-43.91-26.79-70.29c9.25-23.7,20.66-49.38,45.45-55.86c0.05-0.02,0.08-0.03,0.08-0.03 c2.78-0.73,5.75-1.21,8.89-1.41c31.13-2.05,51.79,4.51,51.79,4.51c18.72,16.76,37.27,34.89,41.5,42.73 c1.48,2.74,2.46,4.91,3.08,6.65c0.02,0,0.02,0,0.02,0c2.25,6.31-0.17,7-1.55,7.59c-6.13,2.57-34.63,15.77-43.86,30.01 c0,0,44.89,7.06,48.81,15.5c0.5,1.07,0.86,2.11,1.07,3.16C629.51,224.76,629.4,226.93,628.75,228.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 631.0989,
    y1: 129.1034,
    x2: 558.6182,
    y2: 158.5633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M622.99,173.84c-4.68,1.96-22.37,10.11-34.59,20.18c-6.29-6.23,2.27-13.1-5.02-26.84 c-10.88-20.5-23.67-16.51-33.43-37.22c-5.9-12.52-1.76-16.77,7.42-17.16c14.18,1.4,22.59,4.07,22.59,4.07 c18.72,16.76,37.27,34.89,41.5,42.73c1.48,2.74,2.46,4.91,3.08,6.65c0.02,0,0.02,0,0.02,0 C626.8,172.57,624.38,173.25,622.99,173.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 520.9207,
    y1: 118.0518,
    x2: 489.4438,
    y2: 246.3439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4874,
    style: {
      stopColor: "#5D8898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M517.92,254.05c-5.69-3.95-11.63-8.63-17.38-14.09c-24.12-22.89-37.1-43.91-26.79-70.29 c9.25-23.7,20.66-49.38,45.45-55.86c-1.51,0.75-26.37,13.28-24.83,35.78c1.62,23.88-0.4,27.78-3.14,37.63 c-1.6,5.77-2.01,31.84,25.72,53.1C519.27,242.1,530.9,247.93,517.92,254.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 573.4993,
    y1: 180.4242,
    x2: 558.9036,
    y2: 136.8345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4874,
    style: {
      stopColor: "#5D8898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M587.05,163.43c-2.06,6.1-11.17,16-27.34,11.43c-10.76-3.04-18.84-13.1-19.89-24.82 c-1.41-15.77,9.49-27.47,31.5-17.66C586.05,138.94,590.93,151.94,587.05,163.43z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2643 -0.9644 0.9644 0.2643 264.8821 661.8091)",
    className: "st17",
    cx: 566.24,
    cy: 157.28,
    rx: 16.98,
    ry: 18.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 576.0841,
    y1: 183.7947,
    x2: 562.7361,
    y2: 144.6176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7BB0CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5126,
    style: {
      stopColor: "#4384A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 567.13,
    cy: 157.53,
    r: 14.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 564.039,
    y1: 140.5383,
    x2: 568.8557,
    y2: 166.9739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 567.13,
    cy: 157.53,
    r: 14.59
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 568.41,
    cy: 158.8,
    r: 10.49
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 572.41,
    cy: 153.98,
    r: 2.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.752,
    y1: 241.8065,
    x2: 513.5018,
    y2: 157.767
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4874,
    style: {
      stopColor: "#5D8898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M516.35,132.27c0,0-14.23,6.89-11.9,23.06c1.74,12.04-0.13,21.67,0.84,30.87 c0.97,9.17,6.29,31.47,27.06,31.47c20.77,0,4.04-40.31-0.78-49.87C526.74,158.25,511.68,144.95,516.35,132.27z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3951 -0.9186 0.9186 0.3951 219.6995 650.7792)",
    cx: 603.99,
    cy: 158.57,
    rx: 4.51,
    ry: 2.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 576.7148,
    y1: 209.0898,
    x2: 550.9107,
    y2: 187.3493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4874,
    style: {
      stopColor: "#5D8898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M574.22,184.67c0,0-23.05-2.47-25.81,15.88c-1.79,11.93,6.46,9.78,9.61,7.58 C564.33,203.72,560.42,195.87,574.22,184.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.1871,
    y1: 30.5573,
    x2: 375.6432,
    y2: 111.8048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    style: {
      stopColor: "#6696A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M577.44,116.17c-0.39-0.09-0.84-0.22-1.32-0.33c-0.53-0.12-1.1-0.26-1.74-0.4c-4.12-0.9-10.4-2.05-18.39-2.78 c-0.93-0.08-1.9-0.16-2.88-0.23c-0.08,0-0.16-0.02-0.22-0.02c-0.65-0.05-1.31-0.09-1.97-0.12c-0.65-0.05-1.34-0.08-2.02-0.11 c-0.65-0.03-1.31-0.06-1.99-0.09c-0.73-0.02-1.49-0.05-2.25-0.06c-0.59-0.02-1.18-0.03-1.79-0.03c-4.57-0.08-9.48,0.03-14.69,0.37 c-0.33,0.03-0.65,0.05-0.96,0.08c-0.33,0.02-0.64,0.05-0.96,0.09c-0.26,0.02-0.53,0.05-0.79,0.09c-0.47,0.05-0.93,0.11-1.4,0.19 c-0.37,0.05-0.75,0.11-1.1,0.19c-0.14,0.02-0.26,0.03-0.4,0.06c-0.37,0.06-0.76,0.14-1.13,0.22c-0.08,0.02-0.16,0.03-0.23,0.05 c-0.58,0.12-1.17,0.26-1.73,0.4c-0.06,0.02-0.11,0.03-0.17,0.05c0,0-0.03,0.02-0.08,0.03c-0.28,0.08-0.56,0.14-0.82,0.22 c-0.5,0.14-0.98,0.3-1.46,0.45c-0.73,0.23-1.45,0.48-2.15,0.75c-0.05,0.02-0.09,0.03-0.14,0.05c-0.02,0-0.03,0.02-0.05,0.02 c-0.68,0.28-1.35,0.54-2.01,0.84c-0.64,0.28-1.26,0.58-1.88,0.89c-0.09,0.05-0.2,0.09-0.3,0.16c-0.64,0.31-1.26,0.65-1.87,1 c0,0.02-0.02,0.02-0.02,0.02c-0.64,0.37-1.27,0.75-1.9,1.15c-0.05,0.03-0.09,0.06-0.16,0.09c-0.59,0.39-1.17,0.78-1.73,1.18 c-0.09,0.06-0.19,0.12-0.26,0.19c-0.23,0.19-0.48,0.36-0.72,0.53c-0.25,0.19-0.48,0.36-0.72,0.54c-0.45,0.36-0.92,0.73-1.35,1.1 c-1.34,1.12-2.61,2.3-3.84,3.56c-0.03,0.03-0.08,0.08-0.09,0.11c-0.36,0.36-0.7,0.7-1.03,1.07c-0.42,0.44-0.84,0.89-1.21,1.35 c-0.09,0.09-0.17,0.2-0.25,0.3c-0.47,0.5-0.89,1.03-1.31,1.54c-0.51,0.64-1.03,1.29-1.52,1.96c-0.51,0.65-1,1.34-1.48,2.02 c-0.48,0.65-0.93,1.32-1.38,1.99c-0.08,0.12-0.16,0.23-0.23,0.36c-0.78,1.2-1.54,2.43-2.29,3.68l-0.02-0.02 c-41.06-11.8-69-50.18-196.96-35.64c-25.2,2.86-50.43,8.55-100.66,26.87c17.07-8.58,32.22-19.44,32.84-19.64 c1.06-0.36,92.98-63.75,190.7-63.67c1.12,0,2.24,0,3.34,0.02c69.47,0.75,108.14,23.29,127.45,37.67c2.41,1.8,5.29,4.06,8.49,6.64 v0.02c6.7,5.41,14.83,12.3,23.17,19.67L577.44,116.17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 474.5493,
    y1: 157.2705,
    x2: 478.4341,
    y2: 157.5822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5269,
    style: {
      stopColor: "#131A22",
      stopOpacity: 0.5741
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50",
      stopOpacity: 0
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M474.73,167.17c2.55-6.42,5.27-12.92,8.41-19.11c-3.13,6.19-5.86,12.7-8.4,19.12L474.73,167.17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 482.8417,
    y1: 142.3695,
    x2: 485.8544,
    y2: 142.6112
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5269,
    style: {
      stopColor: "#131A22",
      stopOpacity: 0.5741
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50",
      stopOpacity: 0
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M487.04,140.89c0.75-1.24,1.51-2.47,2.3-3.67c-0.78,1.2-1.54,2.43-2.29,3.68c-1.38,2.32-2.67,4.71-3.92,7.15 C484.37,145.62,485.66,143.21,487.04,140.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.2798,
    y1: 133.6812,
    x2: 491.4855,
    y2: 133.8581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5269,
    style: {
      stopColor: "#131A22",
      stopOpacity: 0.5741
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50",
      stopOpacity: 0
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M489.58,136.87c1.37-2.07,2.83-4.07,4.38-5.97C492.42,132.79,490.96,134.8,489.58,136.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.4359,
    y1: 81.0558,
    x2: 230.5315,
    y2: 46.7008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M309.81,68.89c-32.72-16.49-84.04-24.47-84.04-24.47s2.34,9.64-3.95,10.72c0,0,50.14,8.4,71.36,20.24 L309.81,68.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.928,
    y1: 103.1696,
    x2: 221.0237,
    y2: 68.8147
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M277.27,82.35C252.77,69.08,217.81,66,217.81,66s0.09,9.11-5.1,10.3c0,0,33.57,0.35,50.72,12.73L277.27,82.35 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.4372,
    y1: 120.592,
    x2: 213.5329,
    y2: 86.237
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M251.8,95.07c-11.18-9.68-41.5-9.68-41.5-9.68s3.42,4.8,0,8.17c0,0,23.32-0.36,30.84,7.44L251.8,95.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.7733,
    y1: 237.0898,
    x2: 487.9259,
    y2: 237.0898
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5126,
    style: {
      stopColor: "#78A2B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M485.42,251.1c-2.05,1.72-5.61,3.3-11.63,4.32c-2.98,0.52-6.56,0.89-10.86,1.06 c-18.71,0.79-32.21-0.19-43.07-1.85c-12.12-2.21-22.45-4.83-31.25-7.7c-13.89-4.51-23.96-9.62-31.25-14.52 c-0.02,0-0.02,0-0.03-0.02c-4.95-3.32-8.61-6.54-11.3-9.44c-1.82-1.93-3.19-3.74-4.25-5.3c8.93,2.85,25.88,3.95,52.97,0.76 c51.2-6.03,83.97,17.55,90.64,22.87c1.42,1.14,2.4,2.79,2.53,4.59C488.01,247.44,487.51,249.34,485.42,251.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.2737,
    y1: 213.8576,
    x2: 443.7129,
    y2: 234.6203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5126,
    style: {
      stopColor: "#78A2B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M485.42,251.1c3.16-8.28-27.83-25.2-82.92-20.3c-29.54,2.63-46.86-2.61-56.46-7.85 c-1.82-1.93-3.19-3.74-4.25-5.3c8.93,2.85,25.88,3.95,52.97,0.76c51.2-6.03,83.97,17.55,90.64,22.87c1.42,1.14,2.4,2.79,2.53,4.59 C488.01,247.44,487.51,249.34,485.42,251.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.0647,
    y1: 227.6812,
    x2: 440.5038,
    y2: 248.4438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5126,
    style: {
      stopColor: "#78A2B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M473.78,255.42c-2.98,0.52-6.56,0.89-10.86,1.06c3.87-9.7-23.87-9.57-42.2-7.56c-13,1.43-25.78-0.66-32.12-2 c-13.89-4.51-23.96-9.62-31.25-14.52c14.12,4.85,35.5,10.14,57.77,8.07C461,236.24,479.1,248.04,473.78,255.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.8914,
    y1: 254.8033,
    x2: 408.3773,
    y2: 232.3207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M485.42,251.1c-2.05,1.72-5.61,3.3-11.63,4.32c-2.98,0.52-6.56,0.89-10.86,1.06 c-18.71,0.79-32.21-0.19-43.07-1.85c-12.12-2.21-22.45-4.83-31.25-7.7c-13.89-4.51-23.96-9.62-31.25-14.52 c-0.02,0-0.02,0-0.03-0.02c-4.95-3.32-8.61-6.54-11.3-9.44c-1.82-1.93-3.19-3.74-4.25-5.3c8.93,2.85,25.88,3.95,52.97,0.76 c51.2-6.03,83.97,17.55,90.64,22.87c1.42,1.14,2.4,2.79,2.53,4.59C488.01,247.44,487.51,249.34,485.42,251.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.6153,
    y1: 90.3847,
    x2: 187.5628,
    y2: 144.9234
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M201.91,125.31c-10.95,6.39-24.52,13.29-36.09,16c-0.02-0.02-0.02-0.02-0.02-0.02 c-9.39-1.83-11.61-12.25-6.51-17.97c5.1-5.71,13.95-1.52,22.31,1.96C191.53,129.41,201.91,125.31,201.91,125.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.1145,
    y1: 139.3515,
    x2: 170.6,
    y2: 121.0754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M201.91,125.31c-10.95,6.39-24.52,13.29-36.09,16c-0.02-0.02-0.02-0.02-0.02-0.02 c-9.39-1.83-11.61-12.25-6.51-17.97c5.1-5.71,13.95-1.52,22.31,1.96C191.53,129.41,201.91,125.31,201.91,125.31z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.5585,
    y1: 79.7801,
    x2: 264.411,
    y2: 39.7135,
    gradientTransform: "matrix(1 -2.484892e-03 2.484892e-03 1 -0.3984 1.9731)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M313.74,17.66c-4.73,1.94-9.33,4.18-13.81,6.69c-29.35,16.31-53.91,43.77-78.32,78.11 c3.54,0.96,7.12,2.41,9.62,4.59l0.09-0.02c17.57-10.79,59.35-34.55,109.93-48.21c0.02-0.02,0.02-0.02,0.03-0.02l0.02-0.02h0.03 c7.01-1.91,14.21-3.62,21.53-5.07c7.17-1.41,14.48-2.6,21.86-3.45l0.11-0.02C381.45,48.35,350.9,31.48,313.74,17.66z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.4815,
    y1: 131.9268,
    x2: 189.6524,
    y2: 132.0078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    style: {
      stopColor: "#6696A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M189.9,131.89c0,0.03-0.02,0.05-0.05,0.08c-0.14,0.05-0.3,0.11-0.44,0.16 C189.59,132.03,189.73,131.96,189.9,131.89z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.1626,
    y1: 3.6179,
    x2: 339.9731,
    y2: 124.8602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4167,
    style: {
      stopColor: "#78A2B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M510.4,117.17c-0.64,0.31-1.26,0.65-1.87,1c0,0.02-0.02,0.02-0.02,0.02c-0.64,0.37-1.27,0.75-1.9,1.15 c-0.05,0.03-0.09,0.06-0.16,0.09c-0.59,0.39-1.17,0.78-1.73,1.18c-0.09,0.06-0.19,0.12-0.26,0.19c-0.23,0.19-0.48,0.36-0.72,0.53 c-0.25,0.19-0.48,0.36-0.72,0.54c-0.45,0.36-0.9,0.73-1.35,1.1c-1.34,1.12-2.61,2.3-3.84,3.56c-0.03,0.03-0.08,0.08-0.09,0.11 c-0.36,0.36-0.7,0.72-1.03,1.07c-0.42,0.44-0.84,0.89-1.21,1.35c-0.09,0.09-0.17,0.2-0.25,0.3c-0.45,0.5-0.89,1.01-1.31,1.54 c-0.51,0.64-1.03,1.29-1.52,1.96c-0.51,0.65-1,1.34-1.48,2.02c-0.48,0.65-0.93,1.32-1.38,1.99c-0.08,0.12-0.16,0.23-0.23,0.36 c-0.78,1.2-1.54,2.43-2.29,3.68c-3.25,5.46-6.06,11.35-8.63,17.34c-7.32,8.94-22.81,4.94-55.24-10.19 c-82.65-38.55-208.49-16.59-254.51-7.49c6.67-1.88,13.87-4.98,20.74-8.44c17.07-8.58,32.22-19.44,32.84-19.64 c0.45-0.16,16.84-11.37,42.93-24.35C376.48,66.98,463.64,85.84,510.4,117.17z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M132.27,175.69c-0.07,0.18-0.14,0.39-0.18,0.58l-0.02,0c-0.12-0.04-0.24-0.03-0.35-0.04 C131.87,176.05,132.06,175.86,132.27,175.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M150.79,173.51c-0.49,1.38-0.91,2.77-1.15,4.2l-0.02,0.14c-0.78-0.06-1.58-0.16-2.39-0.22 C148.23,176.09,149.41,174.72,150.79,173.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M110.93,174.25c-2.68-0.23-5.35-0.51-7.97-0.76c1.05-2.32,2.34-4.64,3.97-6.73l0.02,0 c1.26-1.63,2.72-3.09,4.46-4.3c-0.66,1.41-1.23,2.87-1.62,4.34c-0.03,0.04-0.03,0.07-0.04,0.12c-0.72,2.79-0.41,5.53,0.96,7.12 C110.78,174.12,110.87,174.2,110.93,174.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M168.29,175.71c-0.22,1.29-0.24,2.58-0.09,3.77c-1.42-0.14-2.82-0.25-4.24-0.36 c1.31-2.89,3.05-5.59,5.46-7.66C168.95,172.84,168.52,174.28,168.29,175.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M249.45,183.26c-0.15,0.68-0.3,1.35-0.4,2.06c-0.14-0.02-0.29-0.01-0.43-0.02c-0.22,0-0.43-0.02-0.67-0.03 C248.37,184.55,248.88,183.89,249.45,183.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M131.48,173.21c-1.12,0.78-2.22,1.69-3.29,2.69c-2.82-0.27-5.63-0.54-8.42-0.81 c0.21-0.79,0.49-1.62,0.83-2.47c0.74-1.9,1.63-3.81,2.74-5.64c1.6-2.69,3.65-5.18,6.33-7.06c-0.69,1.48-1.27,2.97-1.63,4.48 c-0.22,0.88-0.35,1.78-0.34,2.62c-0.02,1.84,0.44,3.47,1.39,4.58C129.88,172.5,130.69,172.95,131.48,173.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M188.1,181.13c-2.2-0.18-4.43-0.36-6.66-0.54c1.35-4.1,3.39-8.13,6.7-10.98c-0.47,1.41-0.89,2.82-1.1,4.25 C186.59,176.51,186.98,179.21,188.1,181.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M268.11,186.21c-0.01,0.07-0.02,0.14,0,0.22c-0.69-0.03-1.38-0.08-2.07-0.11c0.72-1.47,1.59-2.81,2.68-4 C268.43,183.59,268.18,184.88,268.11,186.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M149.95,170.97c-2.36,1.65-4.73,3.94-6.48,6.32c-2.04-0.18-4.1-0.37-6.13-0.55c0.16-1.87,0.75-4.1,1.67-6.48 c0.4-1.03,0.83-2.08,1.34-3.13c1.75-3.65,4.16-7.18,7.69-9.6c-0.67,1.48-1.25,2.99-1.59,4.51c-0.45,1.82-0.46,3.63-0.03,5.14 c0.22,0.84,0.58,1.6,1.12,2.18C148.34,170.26,149.17,170.72,149.95,170.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M210.04,182.31c-0.21,0.14-0.39,0.31-0.58,0.48c-3.27-0.25-6.62-0.51-9.98-0.77c0.1-0.47,0.23-0.93,0.35-1.4 c1.28-4.71,3.37-9.47,7.13-12.68c-0.47,1.41-0.87,2.84-1.08,4.28c-0.48,3.2,0.16,6.43,1.83,8.36 C208.51,181.49,209.29,181.98,210.04,182.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M287.45,187.73c-0.97-0.06-1.95-0.12-2.92-0.19c0.83-2.23,1.94-4.25,3.47-5.94 c-0.26,1.26-0.48,2.55-0.56,3.88C287.38,186.22,287.39,186.99,287.45,187.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M109.8,148.25c-5.13,3-8.44,7.93-10.7,12.54c-2.33,4.72-3.31,8.95-1.4,10.83c0.57,0.61,1.08,1.14,1.5,1.63 c1.21-2.04,2.55-4.1,4.24-6.12c2.02-2.51,4.79-4.89,7.46-6.52c-0.82-0.18-1.72-0.59-2.55-1.51c-1.23-1.41-1.38-3.81-0.55-6.33 c0.49-1.55,1.29-3.09,2.19-4.64C109.91,148.18,109.88,148.2,109.8,148.25L109.8,148.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M229.09,180.97c-1.1,0.86-2.2,1.88-3.18,2.96c-2.61-0.18-5.27-0.36-7.97-0.55c0.17-1.32,0.48-2.74,0.86-4.23 c1.23-4.55,3.19-9.13,6.71-12.32c0.11-0.13,0.24-0.24,0.38-0.36c-0.04,0.12-0.08,0.25-0.11,0.37c-0.43,1.29-0.75,2.59-0.95,3.91 c-0.48,3.2,0.2,6.48,1.89,8.44C227.54,180.13,228.32,180.62,229.09,180.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M168.56,168.9c-2.41,1.66-4.81,4-6.54,6.41c-0.85,1.15-1.57,2.29-2.25,3.43l-0.02,0 c-1.12-0.08-2.2-0.18-3.32-0.28c-1.11-2.28-0.53-6.06,1.1-10.37c0.1-0.28,0.21-0.55,0.34-0.85c1.75-4.47,4.39-8.97,8.65-11.91 c-0.67,1.5-1.25,3.02-1.59,4.56c-0.66,2.84-0.26,5.69,1.2,7.36C166.94,168.19,167.78,168.64,168.56,168.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M307.16,189.18c-1.28-0.1-2.59-0.17-3.87-0.27c0.89-2.96,2.15-5.71,4.12-7.86 c-0.27,1.29-0.48,2.58-0.56,3.91C306.74,186.38,306.84,187.8,307.16,189.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M127.91,145.54c-5.12,2.98-8.42,7.93-10.66,12.56c-2.3,4.74-3.26,8.99-1.31,10.93 c0.58,0.62,1.1,1.15,1.53,1.66c1.21-2.06,2.54-4.11,4.23-6.14c2.01-2.51,4.77-4.9,7.44-6.5c-0.83-0.19-1.74-0.62-2.59-1.56 c-1.25-1.44-1.42-3.87-0.6-6.41c0.48-1.55,1.27-3.11,2.15-4.66C128.02,145.47,127.98,145.5,127.91,145.54L127.91,145.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M327.16,190.63c-1.59-0.11-3.2-0.22-4.82-0.33c0.84-3.61,2.21-7.02,4.53-9.58 c-0.27,1.29-0.46,2.58-0.52,3.94C326.22,186.68,326.49,188.76,327.16,190.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M248.22,179.79c-1.83,1.42-3.6,3.25-4.99,5.2c-2.07-0.11-4.18-0.23-6.35-0.36 c-0.04-1.94,0.31-4.22,0.98-6.73c1.06-4.11,2.73-8.25,5.59-11.35c0.46-0.5,0.94-0.95,1.45-1.39c-0.15,0.46-0.27,0.93-0.42,1.36 c-0.26,1-0.49,1.98-0.62,2.97c-0.46,3.2,0.24,6.51,1.95,8.5C246.66,178.95,247.44,179.44,248.22,179.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M176.15,166.08c-1.88,5.12-2.32,9.48-0.25,11.53c0.51,0.55,0.92,1.05,1.32,1.55 c1.01-1.92,2.12-3.85,3.52-5.74c1.72-2.43,4.11-4.75,6.52-6.39c-0.79-0.28-1.64-0.75-2.47-1.71c-1.47-1.72-1.9-4.58-1.24-7.46 c0.33-1.54,0.87-3.06,1.53-4.57C180.56,156.4,177.88,161.32,176.15,166.08L176.15,166.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M347.3,191.94c-1.88-0.12-3.75-0.23-5.65-0.35c0.8-4.14,2.19-8.12,4.79-11.01 c-0.24,1.31-0.47,2.63-0.52,3.96C345.76,187.1,346.25,189.76,347.3,191.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M146.12,143c-5.13,2.95-8.41,7.91-10.63,12.57c-2.27,4.76-3.18,9.06-1.21,11.03 c0.58,0.63,1.12,1.17,1.54,1.69c1.2-2.06,2.52-4.12,4.19-6.15c2-2.51,4.77-4.9,7.45-6.49c-0.83-0.2-1.75-0.64-2.61-1.6 c-1.28-1.46-1.48-3.93-0.68-6.48c0.48-1.57,1.27-3.14,2.15-4.7C146.26,142.91,146.21,142.95,146.12,143L146.12,143z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M267.41,178.84c-2.12,1.65-4.17,3.86-5.63,6.18c-0.21,0.34-0.41,0.65-0.61,0.98 c-1.64-0.09-3.25-0.2-4.89-0.29c-0.45-2.32-0.15-5.4,0.72-8.91c0.98-3.81,2.49-7.66,4.99-10.65c0.61-0.74,1.29-1.46,2.03-2.09 c-0.22,0.69-0.42,1.36-0.59,2.06c-0.21,0.77-0.34,1.52-0.45,2.29c-0.41,3.23,0.28,6.56,2.04,8.58 C265.84,177.96,266.64,178.49,267.41,178.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M109.66,146.84c-2.91,1.52-6.08,3.98-8.38,6.53c-1.66,1.8-3.05,3.62-4.29,5.46 c0.3-5.04,1.06-10.14,2.52-15.1c2.32-3,5.27-5.86,8.99-7.85c0.37-0.19,0.62-0.34,0.92-0.5c-1.07,1.52-2.05,3.05-2.67,4.56 c-0.92,2.21-0.92,4.29,0.19,5.49C107.81,146.39,108.8,146.7,109.66,146.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M194.87,164.25c-1.85,5.14-2.27,9.53-0.17,11.63c0.51,0.54,0.96,1.06,1.36,1.56c1-1.92,2.1-3.84,3.49-5.73 c1.72-2.43,4.11-4.75,6.52-6.38c-0.8-0.29-1.65-0.78-2.51-1.75c-1.5-1.75-1.93-4.65-1.29-7.54c0.32-1.56,0.86-3.09,1.51-4.61 C199.25,154.51,196.59,159.46,194.87,164.25L194.87,164.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M367.44,192.95c-2.07-0.09-4.19-0.16-6.31-0.26c0.7-4.51,2.09-8.9,4.9-12c-0.27,1.29-0.44,2.61-0.49,3.94 C365.37,187.55,366.05,190.62,367.44,192.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M286.73,178.08c-2.15,1.62-4.19,3.83-5.62,6.16c-0.64,0.98-1.2,1.94-1.72,2.94c-1-0.07-2.02-0.13-3.04-0.2 c-1.4-2.43-1.26-6.39-0.11-11.06c0.92-3.67,2.29-7.35,4.58-10.27c0.68-0.9,1.46-1.72,2.34-2.46c-0.26,0.78-0.47,1.6-0.63,2.42 c-0.14,0.63-0.24,1.26-0.31,1.9c-0.44,3.25,0.33,6.61,2.08,8.68C285.13,177.16,285.96,177.71,286.73,178.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M165.94,153.41c-2.69,1.59-5.46,3.96-7.45,6.47c-1.68,2.04-3,4.1-4.18,6.17c-0.44-0.53-0.98-1.07-1.57-1.73 c-2.01-2.01-1.12-6.34,1.13-11.13c1.88-4,4.52-8.23,8.5-11.21h0.02c0.54-0.08,1.07-0.17,1.63-0.3c-0.61,1.18-1.12,2.36-1.48,3.55 c-0.79,2.57-0.58,5.05,0.72,6.53C164.15,152.76,165.09,153.21,165.94,153.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M387.26,193.48c-2.15-0.03-4.3-0.06-6.49-0.11c0.73-4.73,2-9.41,4.99-12.59c-0.27,1.36-0.48,2.74-0.52,4.17 C385.09,187.94,385.83,191.11,387.26,193.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M126.44,133.02c-5.34,2.8-9.06,7.47-11.63,11.78c-2.64,4.41-4,8.61-2.11,10.48c0.7,0.74,1.28,1.29,1.74,1.81 c1.39-2.16,2.93-4.33,4.91-6.45c2.29-2.57,5.47-5.02,8.39-6.52c-0.87-0.14-1.87-0.49-2.78-1.47c-1.12-1.22-1.15-3.32-0.24-5.55 c0.6-1.51,1.56-3.05,2.63-4.57C127.08,132.68,126.83,132.83,126.44,133.02L126.44,133.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M213.69,162.6c-1.82,5.17-2.21,9.6-0.07,11.73c0.52,0.57,0.95,1.09,1.36,1.61c0.99-1.94,2.08-3.87,3.47-5.77 c1.71-2.43,4.09-4.74,6.5-6.36c-0.81-0.3-1.67-0.8-2.53-1.78c-1.53-1.78-2-4.7-1.38-7.62c0.31-1.55,0.85-3.09,1.49-4.6 C218.02,152.86,215.38,157.81,213.69,162.6L213.69,162.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M295.56,175.22c-1.33,5.52-1.23,10.02,1,12.27c0.41,0.45,0.78,0.89,1.13,1.32c0.79-1.74,1.7-3.47,2.8-5.17 c1.43-2.32,3.47-4.52,5.6-6.14c-0.79-0.38-1.6-0.92-2.47-1.92c-1.79-2.1-2.55-5.49-2.14-8.75c0.17-1.49,0.53-2.94,0.96-4.37 C298.72,165.6,296.73,170.4,295.56,175.22L295.56,175.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M406.63,193.3c-1.97,0.06-3.98,0.12-6,0.16c0.69-4.59,1.97-9.11,4.85-12.17c-0.25,1.38-0.46,2.77-0.5,4.2 C404.86,188.18,405.45,191.02,406.63,193.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M182.9,138.44c-5.16,2.89-8.39,7.88-10.55,12.58c-2.23,4.81-3.08,9.18-1.04,11.22 c0.61,0.66,1.16,1.23,1.6,1.76c1.18-2.08,2.48-4.15,4.14-6.18c2-2.52,4.76-4.89,7.45-6.46c-0.86-0.22-1.8-0.68-2.7-1.69 c-1.31-1.51-1.54-4.03-0.77-6.6c0.45-1.6,1.22-3.19,2.08-4.76C183.02,138.36,182.99,138.39,182.9,138.44L182.9,138.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M109.3,134.48c-0.23,0.12-0.4,0.17-0.72,0.31c-1.38,0.65-2.83,1.52-4.23,2.49h-0.02 c-1.31,0.92-2.58,1.93-3.7,2.97c0.2-0.56,0.42-1.1,0.64-1.66c0.78-1.94,2.43-4.17,4.57-6.36c0.09,0.36,0.26,0.68,0.53,0.95 C107.33,134.13,108.44,134.38,109.3,134.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M232.61,161.15c-1.79,5.19-2.14,9.65,0.01,11.82c0.53,0.57,0.96,1.1,1.37,1.63 c0.99-1.94,2.09-3.87,3.47-5.77c1.69-2.43,4.08-4.73,6.49-6.35c-0.82-0.3-1.69-0.82-2.56-1.83c-1.54-1.81-2.02-4.76-1.42-7.69 c0.3-1.57,0.82-3.12,1.46-4.64C236.91,151.36,234.28,156.33,232.61,161.15L232.61,161.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M425.65,192.14c-1.62,0.15-3.24,0.28-4.92,0.4c0.72-4.03,2.01-7.86,4.54-10.51 c-0.25,1.36-0.46,2.77-0.48,4.2C424.71,188.2,425,190.27,425.65,192.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M145.96,141.55c-2.94,1.48-6.11,3.92-8.4,6.48c-1.96,2.13-3.51,4.31-4.88,6.47 c-0.48-0.51-1.06-1.09-1.77-1.83c-1.91-1.91-0.61-6.14,2.02-10.57c1.35-2.32,3.05-4.73,5.15-6.9c1.15,1.51,2.6,2.91,4.56,4.06 c0.11,0.3,0.3,0.56,0.5,0.79C144.07,141.04,145.08,141.39,145.96,141.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M314.94,174.72c-1.31,5.54-1.17,10.07,1.1,12.35c0.41,0.45,0.79,0.9,1.12,1.33 c0.78-1.74,1.69-3.46,2.78-5.16c1.42-2.32,3.45-4.5,5.58-6.12c-0.78-0.39-1.6-0.94-2.46-1.95c-1.8-2.13-2.59-5.56-2.21-8.84 c0.16-1.49,0.49-2.94,0.91-4.37C318.05,165.08,316.1,169.9,314.94,174.72L314.94,174.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M444.72,189.32c-1.08,0.26-2.18,0.47-3.3,0.65c0.78-2.66,1.92-5.09,3.68-6.95 c-0.25,1.36-0.43,2.75-0.45,4.18C444.62,187.9,444.66,188.62,444.72,189.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M201.44,136.45c-5.17,2.86-8.38,7.86-10.53,12.58c-2.19,4.83-3.03,9.22-0.95,11.31 c0.61,0.67,1.18,1.25,1.63,1.8c1.17-2.08,2.47-4.15,4.14-6.19c1.98-2.52,4.75-4.89,7.43-6.44c-0.86-0.23-1.81-0.71-2.72-1.73 c-1.33-1.54-1.59-4.09-0.83-6.68c0.44-1.6,1.19-3.19,2.04-4.76C201.57,136.37,201.53,136.4,201.44,136.45L201.44,136.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M251.63,159.88c-1.78,5.21-2.1,9.7,0.09,11.91c0.52,0.59,0.96,1.13,1.39,1.66c0.97-1.94,2.06-3.89,3.44-5.78 c1.69-2.43,4.06-4.73,6.47-6.32c-0.83-0.32-1.71-0.85-2.59-1.87c-1.57-1.84-2.07-4.82-1.49-7.77c0.31-1.58,0.83-3.14,1.46-4.67 C255.87,150.04,253.27,155.03,251.63,159.88L251.63,159.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M334.42,174.43c-1.29,5.56-1.14,10.12,1.15,12.44c0.42,0.46,0.79,0.91,1.14,1.37 c0.78-1.74,1.67-3.47,2.76-5.17c1.42-2.31,3.45-4.49,5.58-6.09c-0.79-0.4-1.62-0.97-2.49-1.99c-1.82-2.16-2.63-5.61-2.26-8.91 c0.15-1.51,0.5-2.98,0.92-4.41C337.49,164.75,335.55,169.58,334.42,174.43L334.42,174.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M127.25,131.61c-0.23,0.09-0.4,0.17-0.7,0.3c-1.52,0.71-3.08,1.64-4.59,2.69c-1.46,1.05-2.86,2.19-4.04,3.37 c-2.23,2.14-4.04,4.37-5.6,6.56c-0.47-0.48-1.16-0.99-1.97-1.83c-1.29-1.27-0.75-3.7,0.76-6.47c0.58-1.08,1.33-2.22,2.15-3.37 c2.1-2.9,4.91-6,8.47-8.46c1.28-0.29,2.58-0.57,3.9-0.9c-0.48,0.69-0.92,1.35-1.26,2.03c-0.98,1.9-1.04,3.66-0.08,4.7 C125.26,131.22,126.4,131.49,127.25,131.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M159.36,142.36c-1.27,1.01-2.47,2.13-3.48,3.27c-1.96,2.13-3.5,4.32-4.87,6.5c-0.47-0.53-1.07-1.12-1.79-1.9 c-1.62-1.62-1.03-4.79,0.72-8.36c1.77,0.33,3.75,0.54,6,0.61C157.05,142.5,158.18,142.47,159.36,142.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M353.94,174.35c-1.25,5.58-1.08,10.16,1.23,12.52c0.42,0.47,0.81,0.94,1.17,1.39 c0.76-1.75,1.65-3.48,2.73-5.17c1.41-2.32,3.43-4.49,5.57-6.08c-0.8-0.41-1.63-0.99-2.5-2.02c-1.85-2.21-2.67-5.68-2.33-8.99 c0.14-1.51,0.47-2.97,0.87-4.41C356.96,164.66,355.05,169.5,353.94,174.35L353.94,174.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M270.73,158.81c-1.75,5.23-2.04,9.75,0.17,11.99c0.53,0.59,1,1.14,1.41,1.67c0.97-1.94,2.04-3.88,3.4-5.76 c1.69-2.43,4.07-4.72,6.49-6.3c-0.83-0.33-1.72-0.88-2.62-1.91c-1.59-1.87-2.11-4.88-1.55-7.84c0.29-1.58,0.8-3.14,1.41-4.67 C274.92,148.97,272.34,153.96,270.73,158.81L270.73,158.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M220.11,134.63c-5.18,2.83-8.38,7.84-10.5,12.58c-2.18,4.84-2.98,9.26-0.88,11.39 c0.62,0.68,1.19,1.27,1.65,1.82c1.16-2.09,2.46-4.17,4.11-6.2c1.98-2.52,4.73-4.87,7.42-6.4c-0.86-0.25-1.82-0.74-2.73-1.78 c-1.35-1.57-1.65-4.14-0.91-6.75c0.43-1.6,1.17-3.18,2.01-4.75C220.22,134.58,220.18,134.6,220.11,134.63L220.11,134.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M373.55,174.48c-1.24,5.6-1.02,10.2,1.3,12.6c0.43,0.47,0.81,0.93,1.17,1.4c0.76-1.75,1.64-3.47,2.72-5.16 c1.4-2.31,3.42-4.47,5.55-6.04c-0.79-0.42-1.63-1.01-2.51-2.06c-1.87-2.23-2.71-5.74-2.37-9.07c0.14-1.51,0.45-2.98,0.87-4.42 C376.55,164.78,374.64,169.62,373.55,174.48L373.55,174.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M137.29,134.04c-0.45,0.39-0.89,0.79-1.29,1.2c-2.22,2.16-4.04,4.37-5.6,6.56 c-0.47-0.48-1.15-1.01-1.99-1.85c-1.29-1.27-0.84-3.65,0.61-6.36c0.58-1.17,1.34-2.36,2.21-3.56c0.75-1.03,1.57-2.08,2.49-3.13 C134.78,129.1,135.73,131.65,137.29,134.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M182.69,136.96c-2.94,1.45-6.11,3.87-8.38,6.44c-1.96,2.11-3.48,4.32-4.84,6.5 c-0.48-0.54-1.09-1.14-1.83-1.93c-1.43-1.45-1.17-4.09,0.08-7.14h0.02c4.2-1.12,8.61-2.74,13.04-4.65 C181.43,136.62,182.1,136.84,182.69,136.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M289.93,157.93c-1.73,5.25-2.01,9.79,0.22,12.09c0.53,0.59,1.01,1.15,1.43,1.69 c0.96-1.95,2.02-3.88,3.38-5.78c1.68-2.43,4.06-4.7,6.48-6.26c-0.84-0.34-1.74-0.9-2.65-1.96c-1.6-1.9-2.15-4.93-1.6-7.91 c0.28-1.59,0.78-3.15,1.39-4.68C294.07,148.07,291.51,153.07,289.93,157.93L289.93,157.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M238.84,133c-5.18,2.8-8.34,7.82-10.44,12.58c-2.14,4.86-2.92,9.31-0.8,11.48c0.63,0.69,1.21,1.29,1.67,1.85 c1.16-2.09,2.45-4.17,4.09-6.2c1.98-2.52,4.73-4.86,7.42-6.38c-0.87-0.26-1.84-0.77-2.77-1.82c-1.38-1.6-1.69-4.19-0.98-6.81 c0.43-1.63,1.17-3.22,2.03-4.8C238.97,132.93,238.93,132.97,238.84,133L238.84,133z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M393.21,174.83c-1.22,5.61-0.97,10.25,1.38,12.68c0.43,0.48,0.81,0.95,1.18,1.4 c0.75-1.74,1.63-3.46,2.7-5.14c1.4-2.3,3.4-4.45,5.55-6.01c-0.8-0.43-1.64-1.03-2.54-2.1c-1.87-2.26-2.75-5.8-2.43-9.14 c0.13-1.51,0.43-2.97,0.83-4.41C396.17,165.13,394.27,169.96,393.21,174.83L393.21,174.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M309.19,157.27c-1.7,5.26-1.96,9.84,0.3,12.16c0.54,0.61,1.02,1.17,1.45,1.72c0.95-1.94,2-3.88,3.36-5.77 c1.68-2.43,4.04-4.69,6.46-6.25c-0.83-0.35-1.73-0.92-2.66-2c-1.61-1.93-2.17-4.97-1.64-7.97c0.26-1.6,0.75-3.17,1.37-4.7 C313.3,147.38,310.76,152.37,309.19,157.27L309.19,157.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M201.24,134.94c-2.95,1.43-6.13,3.84-8.4,6.41c-1.94,2.13-3.47,4.32-4.82,6.5c-0.5-0.56-1.1-1.15-1.85-1.96 c-2.01-2.04-0.79-6.34,1.76-10.81c0.58-1.03,1.21-2.07,1.93-3.11c2.58-0.95,5.08-1.85,7.53-2.72c-0.25,1.62,0.05,3.06,0.93,4.04 C199.28,134.37,200.33,134.76,201.24,134.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M412.96,175.4c-1.19,5.63-0.95,10.28,1.41,12.75c0.43,0.49,0.83,0.96,1.19,1.44 c0.75-1.74,1.63-3.48,2.69-5.15c1.38-2.3,3.4-4.43,5.53-5.97c-0.81-0.44-1.66-1.06-2.56-2.14c-1.89-2.29-2.77-5.86-2.46-9.21 c0.12-1.52,0.42-2.99,0.81-4.43C415.87,165.68,414,170.52,412.96,175.4L412.96,175.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M257.69,131.59c-5.2,2.77-8.35,7.78-10.43,12.55c-2.13,4.88-2.86,9.36-0.71,11.56 c0.65,0.71,1.22,1.32,1.7,1.89c1.14-2.09,2.41-4.18,4.05-6.19c1.96-2.52,4.73-4.85,7.43-6.36c-0.87-0.27-1.85-0.79-2.79-1.87 c-1.41-1.63-1.72-4.24-1.02-6.88c0.42-1.62,1.14-3.23,1.97-4.81C257.81,131.52,257.77,131.54,257.69,131.59L257.69,131.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M432.74,176.2c-1.17,5.63-0.91,10.32,1.47,12.83c0.44,0.49,0.84,0.98,1.2,1.47 c0.75-1.75,1.61-3.47,2.68-5.15c1.38-2.3,3.38-4.42,5.52-5.93c-0.81-0.46-1.67-1.08-2.58-2.18c-1.9-2.32-2.8-5.91-2.5-9.28 c0.12-1.52,0.41-3,0.79-4.44C435.62,166.47,433.76,171.31,432.74,176.2L432.74,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M328.53,156.81c-1.67,5.28-1.88,9.88,0.39,12.24c0.55,0.61,1.03,1.18,1.46,1.74c0.94-1.95,2-3.88,3.35-5.76 c1.67-2.42,4.02-4.68,6.44-6.21c-0.85-0.36-1.75-0.95-2.67-2.03c-1.63-1.96-2.24-5.05-1.71-8.05c0.26-1.61,0.76-3.18,1.36-4.73 C332.6,146.89,330.07,151.9,328.53,156.81L328.53,156.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M219.88,133.12c-2.97,1.4-6.14,3.79-8.4,6.36c-1.96,2.11-3.47,4.32-4.8,6.51c-0.5-0.58-1.14-1.2-1.88-2.01 c-2.05-2.08-0.84-6.41,1.69-10.9c1.96-3.51,4.7-7.23,8.49-9.92c1.07-0.36,2.11-0.72,3.16-1.06c-0.7,1.15-1.32,2.3-1.73,3.45 c-0.84,2.29-0.7,4.51,0.51,5.86C217.92,132.52,218.98,132.92,219.88,133.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M463.49,180.57c-1.92,1.36-3.73,3.19-5.04,5.22l-0.02,0c-1.89,0.62-3.82,1.19-5.82,1.73 c-0.95-2.62-0.87-6.22-0.03-10.29c1.01-4.88,2.85-9.72,6.55-12.65c-0.4,1.44-0.69,2.91-0.79,4.45c-0.29,3.36,0.64,6.99,2.55,9.33 C461.82,179.47,462.68,180.12,463.49,180.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M276.62,130.36c-5.2,2.73-8.32,7.76-10.37,12.54c-2.11,4.89-2.81,9.4-0.65,11.64 c0.65,0.71,1.25,1.34,1.72,1.92c1.13-2.1,2.4-4.18,4.04-6.21c1.96-2.52,4.72-4.83,7.42-6.31c-0.89-0.29-1.87-0.82-2.83-1.92 c-1.41-1.65-1.75-4.3-1.06-6.94c0.41-1.65,1.13-3.25,1.96-4.84C276.75,130.29,276.71,130.32,276.62,130.36L276.62,130.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M347.95,156.55c-1.65,5.29-1.85,9.92,0.44,12.32c0.56,0.63,1.04,1.21,1.49,1.78 c0.93-1.95,1.98-3.89,3.32-5.77c1.67-2.42,4.04-4.65,6.45-6.17c-0.86-0.37-1.78-0.97-2.71-2.08c-1.66-1.99-2.26-5.09-1.74-8.11 c0.25-1.6,0.72-3.18,1.31-4.72C351.99,146.65,349.48,151.64,347.95,156.55L347.95,156.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M236.6,119.63c-5.42,2.59-9.04,7.29-11.46,11.68c-2.51,4.5-3.69,8.84-1.62,10.96 c0.77,0.83,1.4,1.47,1.91,2.05c1.33-2.19,2.83-4.4,4.77-6.52c2.26-2.56,5.43-4.94,8.4-6.32c-0.9-0.21-1.97-0.65-2.97-1.75 c-1.23-1.38-1.39-3.6-0.57-5.9c0.55-1.58,1.46-3.14,2.49-4.69C237.26,119.31,237,119.44,236.6,119.63L236.6,119.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M295.66,129.36c-5.21,2.69-8.32,7.71-10.35,12.51c-2.08,4.9-2.77,9.42-0.57,11.71 c0.66,0.73,1.26,1.37,1.74,1.96c1.13-2.1,2.39-4.2,4.03-6.22c1.95-2.51,4.71-4.81,7.41-6.27c-0.9-0.29-1.89-0.84-2.86-1.96 c-1.42-1.68-1.8-4.35-1.12-7.01c0.39-1.63,1.1-3.24,1.92-4.82C295.77,129.29,295.74,129.32,295.66,129.36L295.66,129.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M367.44,156.53c-1.63,5.3-1.8,9.95,0.51,12.39c0.56,0.63,1.05,1.22,1.49,1.79c0.93-1.95,1.97-3.88,3.31-5.75 c1.66-2.42,4.02-4.65,6.44-6.14c-0.87-0.38-1.78-1-2.73-2.12c-1.67-2.02-2.31-5.14-1.82-8.18c0.25-1.61,0.73-3.19,1.31-4.73 C371.43,146.6,368.95,151.6,367.44,156.53L367.44,156.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M387,156.71c-1.61,5.32-1.75,9.99,0.57,12.46c0.56,0.65,1.06,1.25,1.51,1.82c0.91-1.95,1.96-3.88,3.3-5.74 c1.63-2.41,4-4.62,6.41-6.1c-0.86-0.4-1.78-1.02-2.74-2.16c-1.68-2.05-2.33-5.21-1.85-8.25c0.24-1.62,0.71-3.2,1.29-4.75 C390.96,146.77,388.5,151.78,387,156.71L387,156.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M314.77,128.55c-5.21,2.65-8.32,7.68-10.32,12.48c-2.07,4.92-2.72,9.47-0.5,11.79 c0.66,0.74,1.27,1.39,1.76,1.99c1.12-2.1,2.37-4.19,4.01-6.2c1.94-2.51,4.7-4.8,7.42-6.23c-0.91-0.31-1.9-0.87-2.89-2.01 c-1.45-1.71-1.84-4.4-1.19-7.07c0.39-1.65,1.11-3.26,1.92-4.85C314.89,128.49,314.85,128.51,314.77,128.55L314.77,128.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M255.34,118.08c-5.43,2.55-9.04,7.23-11.44,11.64c-2.49,4.51-3.63,8.89-1.54,11.04 c0.77,0.84,1.42,1.49,1.94,2.07c1.32-2.2,2.81-4.39,4.75-6.51c2.25-2.54,5.43-4.92,8.4-6.28c-0.92-0.22-2-0.67-3.02-1.79 c-1.24-1.4-1.41-3.66-0.6-5.97c0.53-1.57,1.44-3.14,2.46-4.67C255.97,117.77,255.72,117.9,255.34,118.08L255.34,118.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M211.23,124.43c-0.67,0.54-1.29,1.09-1.87,1.66c-2.22,2.15-3.95,4.35-5.49,6.58 c-0.51-0.53-1.24-1.1-2.13-2.04c-0.67-0.65-0.93-1.55-0.86-2.63C204.47,126.75,207.92,125.55,211.23,124.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M406.63,157.13c-1.59,5.32-1.71,10,0.62,12.53c0.58,0.65,1.08,1.26,1.53,1.84c0.91-1.94,1.94-3.88,3.28-5.74 c1.64-2.4,3.99-4.59,6.41-6.05c-0.86-0.41-1.79-1.05-2.76-2.2c-1.69-2.08-2.35-5.25-1.9-8.3c0.23-1.64,0.7-3.23,1.28-4.78 C410.55,147.17,408.1,152.18,406.63,157.13L406.63,157.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M333.96,127.97c-5.23,2.61-8.29,7.63-10.28,12.44c-2.04,4.92-2.68,9.5-0.44,11.87 c0.67,0.75,1.28,1.42,1.77,2.02c1.11-2.1,2.35-4.19,3.98-6.2c1.94-2.5,4.69-4.77,7.41-6.2c-0.91-0.32-1.91-0.91-2.9-2.05 c-1.47-1.74-1.87-4.45-1.23-7.13c0.38-1.66,1.08-3.28,1.9-4.86C334.09,127.9,334.05,127.93,333.96,127.97L333.96,127.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M274.15,116.72c-5.43,2.51-9.04,7.2-11.42,11.61c-2.47,4.52-3.57,8.91-1.45,11.1 c0.79,0.87,1.44,1.53,1.96,2.12c1.31-2.2,2.8-4.4,4.72-6.52c2.24-2.54,5.41-4.89,8.4-6.23c-0.92-0.24-2.01-0.69-3.03-1.84 c-1.27-1.43-1.47-3.7-0.68-6.02c0.52-1.58,1.43-3.15,2.44-4.69C274.79,116.41,274.54,116.54,274.15,116.72L274.15,116.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M426.31,157.77c-1.56,5.33-1.67,10.04,0.69,12.61c0.57,0.67,1.08,1.28,1.54,1.88 c0.9-1.95,1.93-3.88,3.26-5.73c1.64-2.4,3.99-4.57,6.42-6c-0.87-0.43-1.81-1.08-2.78-2.25c-1.7-2.11-2.39-5.31-1.94-8.37 c0.22-1.63,0.68-3.22,1.25-4.77C430.21,147.82,427.78,152.82,426.31,157.77L426.31,157.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M237.39,118.2c-0.25,0.09-0.42,0.14-0.73,0.26c-3.03,1.27-6.28,3.47-8.66,5.83 c-2.22,2.13-3.96,4.34-5.47,6.56c-0.53-0.54-1.27-1.14-2.18-2.07c-1.57-1.57-0.93-4.49,0.81-7.65c4.76-1.54,9.24-2.94,13.48-4.2 C235.58,117.75,236.59,118.04,237.39,118.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M353.24,127.6c-5.23,2.55-8.28,7.58-10.25,12.41c-2.02,4.93-2.64,9.52-0.38,11.93 c0.68,0.77,1.31,1.44,1.8,2.05c1.11-2.1,2.35-4.19,3.97-6.19c1.93-2.49,4.69-4.75,7.41-6.15c-0.92-0.34-1.94-0.93-2.94-2.1 c-1.48-1.77-1.9-4.49-1.27-7.19c0.38-1.66,1.07-3.28,1.87-4.87C353.37,127.53,353.33,127.56,353.24,127.6L353.24,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M446.08,158.65c-1.55,5.33-1.66,10.07,0.73,12.66c0.58,0.68,1.09,1.3,1.55,1.9 c0.89-1.94,1.91-3.87,3.24-5.72c1.62-2.38,3.97-4.54,6.4-5.95c-0.87-0.43-1.81-1.1-2.78-2.28c-1.72-2.13-2.42-5.36-1.97-8.43 c0.22-1.64,0.67-3.23,1.24-4.78C449.93,148.7,447.51,153.69,446.08,158.65L446.08,158.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M293.07,115.59c-5.45,2.46-9.02,7.14-11.39,11.56c-2.45,4.52-3.54,8.94-1.4,11.18 c0.8,0.88,1.45,1.54,1.98,2.14c1.31-2.2,2.78-4.4,4.71-6.5c2.24-2.54,5.42-4.87,8.41-6.18c-0.93-0.25-2.02-0.73-3.06-1.89 c-1.27-1.45-1.5-3.74-0.72-6.07c0.52-1.58,1.42-3.14,2.42-4.68C293.72,115.29,293.46,115.41,293.07,115.59L293.07,115.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M476.76,162.14c-0.26,0.62-0.51,1.26-0.76,1.88c-1.74,1.29-3.34,2.94-4.57,4.7 c-1.31,1.82-2.32,3.75-3.22,5.69c-0.47-0.61-0.98-1.23-1.54-1.91c-2.41-2.64-2.32-7.39-0.79-12.73c1.41-4.94,3.82-9.94,8.36-12.53 c-0.56,1.54-1.01,3.13-1.23,4.77c-0.42,3.06,0.28,6.31,2.02,8.47C475.63,161.2,476.2,161.73,476.76,162.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M372.6,127.46c-5.23,2.51-8.26,7.53-10.22,12.37c-2,4.94-2.61,9.56-0.32,12c0.69,0.77,1.32,1.46,1.81,2.08 c1.1-2.1,2.32-4.19,3.94-6.18c1.93-2.49,4.67-4.72,7.39-6.1c-0.91-0.34-1.93-0.95-2.94-2.14c-1.5-1.79-1.94-4.54-1.32-7.24 c0.36-1.67,1.05-3.29,1.85-4.88C372.73,127.4,372.69,127.42,372.6,127.46L372.6,127.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M256.09,116.63c-0.25,0.09-0.4,0.14-0.72,0.26c-3.05,1.24-6.3,3.42-8.66,5.77 c-2.21,2.13-3.95,4.35-5.46,6.58c-0.54-0.54-1.29-1.15-2.21-2.11c-2.04-2.05-0.45-6.25,2.36-10.32c0.51-0.76,1.07-1.52,1.68-2.29 c0,0,0,0,0.02,0c3.08-0.86,6.05-1.63,8.91-2.35c-0.08,1.07,0.2,2.04,0.86,2.75C253.96,116.05,255.17,116.42,256.09,116.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M312.08,114.65c-5.46,2.42-9.03,7.09-11.37,11.52c-2.43,4.53-3.47,8.97-1.31,11.25 c0.81,0.89,1.47,1.57,2,2.18c1.3-2.2,2.76-4.4,4.68-6.5c2.24-2.54,5.42-4.85,8.4-6.13c-0.94-0.26-2.04-0.75-3.1-1.94 c-1.29-1.47-1.52-3.79-0.75-6.12c0.51-1.59,1.4-3.16,2.4-4.7C312.72,114.35,312.47,114.47,312.08,114.65L312.08,114.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M392.03,127.55c-5.24,2.46-8.28,7.48-10.21,12.31c-1.98,4.95-2.54,9.58-0.22,12.07 c0.69,0.79,1.32,1.48,1.82,2.11c1.1-2.1,2.32-4.19,3.93-6.17c1.93-2.48,4.67-4.69,7.39-6.05c-0.91-0.35-1.94-0.98-2.97-2.18 c-1.51-1.83-1.96-4.59-1.36-7.3c0.36-1.68,1.04-3.3,1.82-4.9C392.17,127.48,392.13,127.51,392.03,127.55L392.03,127.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M274.9,115.27c-0.25,0.09-0.4,0.14-0.73,0.26c-3.03,1.21-6.3,3.36-8.66,5.71c-2.21,2.11-3.93,4.34-5.43,6.56 c-0.56-0.56-1.31-1.18-2.22-2.16c-2.07-2.08-0.53-6.3,2.29-10.39c1.41-2.08,3.2-4.24,5.4-6.16c2.05-0.42,4.06-0.81,6.03-1.15 c-0.09,0.16-0.17,0.31-0.23,0.47c-0.89,1.97-0.81,3.89,0.31,5.1C272.76,114.68,274,115.07,274.9,115.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M331.17,113.93c-5.47,2.37-9.01,7.04-11.34,11.47c-2.43,4.53-3.46,8.99-1.27,11.3 c0.8,0.89,1.52,1.58,2.06,2.2c1.28-2.19,2.73-4.38,4.63-6.46c2.24-2.52,5.42-4.81,8.42-6.08c-0.95-0.27-2.07-0.77-3.14-1.98 c-1.31-1.51-1.55-3.84-0.79-6.18c0.5-1.6,1.38-3.16,2.37-4.7C331.82,113.64,331.57,113.76,331.17,113.93L331.17,113.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M411.54,127.87c-5.25,2.41-8.28,7.42-10.18,12.25c-1.96,4.95-2.52,9.6-0.19,12.13 c0.7,0.8,1.33,1.51,1.86,2.15c1.08-2.1,2.3-4.18,3.9-6.16c1.92-2.47,4.67-4.66,7.39-5.99c-0.92-0.37-1.94-1-2.98-2.23 c-1.53-1.85-2.02-4.64-1.41-7.36c0.35-1.67,1.02-3.3,1.81-4.89C411.66,127.8,411.62,127.83,411.54,127.87L411.54,127.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M431.11,128.43c-5.26,2.36-8.26,7.36-10.14,12.2c-1.96,4.95-2.49,9.61-0.15,12.18 c0.71,0.81,1.36,1.53,1.87,2.18c1.07-2.1,2.3-4.17,3.89-6.15c1.92-2.45,4.65-4.63,7.38-5.93c-0.92-0.38-1.96-1.03-3-2.28 c-1.54-1.88-2.04-4.68-1.44-7.4c0.34-1.69,1.01-3.31,1.8-4.9C431.25,128.37,431.2,128.39,431.11,128.43L431.11,128.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M293.83,114.12c-0.26,0.09-0.42,0.12-0.73,0.25c-3.05,1.2-6.33,3.33-8.68,5.66 c-2.21,2.1-3.92,4.32-5.41,6.55c-0.56-0.56-1.32-1.2-2.25-2.19c-2.1-2.13-0.56-6.36,2.21-10.43c1.99-2.95,4.71-6.05,8.3-8.35 c0.93-0.12,1.88-0.23,2.81-0.34c0.42-0.05,0.82-0.09,1.23-0.14c-0.45,0.68-0.84,1.37-1.14,2.05c-0.86,1.99-0.78,3.9,0.36,5.13 C291.65,113.49,292.89,113.91,293.83,114.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M350.35,113.44c-5.49,2.32-9.02,6.98-11.32,11.41c-2.39,4.54-3.4,9.01-1.19,11.37 c0.84,0.93,1.52,1.64,2.05,2.27c1.29-2.21,2.74-4.4,4.66-6.49c2.22-2.52,5.38-4.78,8.38-6.02c-0.95-0.29-2.06-0.82-3.15-2.04 c-1.32-1.53-1.56-3.87-0.82-6.23c0.48-1.6,1.35-3.17,2.34-4.7C351,113.15,350.74,113.28,350.35,113.44L350.35,113.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M240.45,115.26c-0.47,0.54-0.92,1.1-1.34,1.65c-0.31-0.26-0.73-0.54-1.23-0.92 C238.75,115.74,239.61,115.49,240.45,115.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M450.76,129.23c-5.27,2.3-8.24,7.29-10.12,12.13c-1.93,4.95-2.46,9.64-0.1,12.24 c0.72,0.82,1.36,1.55,1.89,2.22c1.07-2.1,2.28-4.17,3.89-6.13c1.89-2.44,4.62-4.59,7.35-5.87c-0.93-0.39-1.98-1.06-3.02-2.32 c-1.54-1.91-2.05-4.74-1.47-7.47c0.34-1.68,1.01-3.3,1.79-4.9C450.88,129.16,450.83,129.19,450.76,129.23L450.76,129.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M369.62,113.17c-5.49,2.27-9,6.92-11.3,11.35c-2.37,4.54-3.38,9.03-1.14,11.43c0.81,0.92,1.54,1.64,2.1,2.27 c1.27-2.19,2.71-4.37,4.61-6.43c2.22-2.5,5.39-4.74,8.41-5.95c-0.95-0.3-2.07-0.84-3.18-2.09c-1.32-1.55-1.62-3.93-0.88-6.29 c0.48-1.6,1.35-3.17,2.33-4.7C370.26,112.9,370.01,113.01,369.62,113.17L369.62,113.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M312.81,113.19c-0.25,0.09-0.42,0.12-0.73,0.23c-3.05,1.18-6.31,3.3-8.66,5.61c-2.21,2.1-3.92,4.31-5.4,6.55 c-0.56-0.59-1.34-1.24-2.29-2.25c-2.11-2.16-0.62-6.42,2.16-10.5c2.29-3.41,5.54-7,10-9.31c0.98-0.08,1.94-0.16,2.89-0.23 c-0.68,0.95-1.27,1.9-1.66,2.86c-0.87,1.99-0.78,3.92,0.37,5.16C310.63,112.52,311.86,112.96,312.81,113.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M473.44,144.96c-2.74,1.24-5.47,3.37-7.39,5.82c-1.59,1.94-2.78,4.01-3.84,6.11 c-0.53-0.67-1.18-1.41-1.9-2.25c-2.39-2.64-1.9-7.35,0.02-12.3c1.32-3.44,3.22-6.93,6.09-9.48c0.9,0.42,1.8,0.84,2.71,1.24 c-0.11,0.33-0.19,0.65-0.25,0.98c-0.56,2.74-0.05,5.58,1.51,7.51C471.45,143.87,472.5,144.55,473.44,144.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M263.23,109.58c-2.15,1.87-3.89,3.81-5.4,5.77c-0.54-0.47-1.49-1-2.53-2.04c-0.5-0.48-0.73-1.09-0.78-1.77 C257.52,110.83,260.41,110.17,263.23,109.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M487.04,140.9c-2.71,4.57-5.13,9.44-7.35,14.4c-1.87-2.74-1.34-7.14,0.45-11.74 c0.54-1.43,1.18-2.86,1.94-4.23C483.71,139.89,485.36,140.42,487.04,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M388.95,113.14c-5.5,2.22-8.99,6.85-11.27,11.28c-2.36,4.54-3.34,9.04-1.07,11.48 c0.82,0.94,1.55,1.66,2.11,2.32c1.26-2.2,2.7-4.37,4.59-6.42c2.22-2.5,5.39-4.71,8.4-5.89c-0.96-0.32-2.1-0.87-3.19-2.14 c-1.35-1.58-1.65-3.97-0.92-6.32c0.48-1.62,1.35-3.18,2.33-4.72C389.61,112.87,389.35,112.99,388.95,113.14L388.95,113.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M331.89,112.48c-0.23,0.08-0.4,0.12-0.7,0.23c-3.06,1.14-6.33,3.23-8.69,5.55c-2.19,2.07-3.9,4.29-5.38,6.51 c-0.58-0.59-1.35-1.26-2.32-2.29c-2.13-2.21-0.65-6.47,2.1-10.56c2.41-3.58,5.86-7.37,10.71-9.61c0.79-0.03,1.59-0.06,2.36-0.09 c-0.76,1.03-1.41,2.05-1.85,3.11c-0.82,1.99-0.73,3.95,0.44,5.21C329.69,111.78,330.95,112.24,331.89,112.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M285.15,105.87c-0.87,0.56-1.69,1.18-2.44,1.8c-2.46,2.01-4.4,4.17-6.06,6.34c-0.56-0.5-1.52-1.03-2.58-2.1 c-1.06-1.04-1.03-2.6-0.31-4.35C277.64,106.89,281.4,106.33,285.15,105.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M408.38,113.34c-5.51,2.16-9,6.78-11.25,11.21c-2.36,4.54-3.33,9.06-1.04,11.54 c0.87,0.98,1.55,1.71,2.12,2.38c1.26-2.2,2.7-4.38,4.6-6.43c2.21-2.48,5.39-4.68,8.39-5.82c-0.96-0.33-2.11-0.9-3.22-2.18 c-1.37-1.6-1.66-4.02-0.95-6.38c0.47-1.61,1.33-3.17,2.29-4.7C409.02,113.08,408.77,113.2,408.38,113.34L408.38,113.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M351.07,111.98c-0.25,0.08-0.42,0.12-0.73,0.23c-3.08,1.12-6.34,3.17-8.68,5.47 c-2.19,2.08-3.9,4.28-5.35,6.5c-0.58-0.59-1.37-1.27-2.35-2.33c-2.18-2.25-0.7-6.51,2.02-10.59c2.29-3.42,5.54-7,10.04-9.24 c0.92,0,1.83,0.02,2.74,0.03c-0.64,0.89-1.17,1.79-1.54,2.69c-0.84,1.99-0.72,3.96,0.47,5.26 C348.87,111.26,350.14,111.73,351.07,111.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M430.77,126.76c-3.02,1.12-6.19,3.28-8.4,5.75c-1.88,2.04-3.33,4.2-4.57,6.37 c-0.56-0.67-1.31-1.43-2.15-2.39c-2.3-2.52-1.37-7.04,0.95-11.57c1.94-3.84,4.82-7.81,9.14-10.15c0.64,0.22,1.26,0.45,1.88,0.67 c-0.45,0.87-0.84,1.77-1.1,2.67c-0.7,2.36-0.39,4.77,1,6.41C428.66,125.83,429.79,126.42,430.77,126.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M293.28,104.9c4.28-0.45,8.44-0.86,12.5-1.21c-1.51,0.86-2.95,1.83-4.17,2.86 c-2.47,2.01-4.42,4.17-6.06,6.33c-0.56-0.5-1.54-1.06-2.6-2.16C291.6,109.4,291.99,107.24,293.28,104.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M370.32,111.73c-0.25,0.06-0.42,0.11-0.73,0.2c-3.08,1.09-6.33,3.13-8.68,5.41 c-2.18,2.05-3.86,4.21-5.32,6.42c-0.58-0.59-1.45-1.29-2.38-2.32c-2.21-2.29-0.76-6.56,1.96-10.63c1.94-2.94,4.63-5.97,8.21-8.18 c1.27,0.06,2.55,0.16,3.79,0.26c-0.3,0.5-0.54,1-0.75,1.49c-0.84,2.01-0.7,3.98,0.5,5.3C368.1,110.97,369.37,111.45,370.32,111.73 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M450.4,127.56c-3.03,1.07-6.2,3.22-8.4,5.68c-1.88,2.01-3.31,4.17-4.56,6.34c-0.58-0.68-1.32-1.45-2.16-2.43 c-2.32-2.55-1.41-7.11,0.92-11.63c0.9-1.8,2.02-3.62,3.39-5.29c2.21,0.96,4.32,1.91,6.41,2.88c0.23,0.79,0.61,1.54,1.13,2.16 C448.26,126.59,449.42,127.2,450.4,127.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M312.64,103.16c4.45-0.33,8.75-0.58,12.94-0.76c-1.82,0.92-3.56,2.05-4.99,3.25 c-2.46,1.99-4.38,4.14-6.03,6.3c-0.58-0.51-1.54-1.09-2.63-2.19C310.42,108.26,311.01,105.77,312.64,103.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M464.28,131.83c-0.95,0.72-1.82,1.52-2.58,2.36c-1.88,1.99-3.3,4.14-4.56,6.31 c-0.58-0.68-1.32-1.48-2.18-2.47c-2.15-2.38-1.57-6.41,0.33-10.53C458.36,128.99,461.34,130.45,464.28,131.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M389.66,111.7c-0.25,0.06-0.4,0.09-0.72,0.2c-3.09,1.06-6.37,3.05-8.71,5.33c-2.18,2.04-3.84,4.2-5.3,6.41 c-0.58-0.61-1.46-1.34-2.41-2.36c-2.21-2.33-0.78-6.62,1.93-10.68c1.46-2.22,3.34-4.51,5.72-6.42c1.8,0.22,3.58,0.47,5.3,0.72 c-0.54,1.79-0.31,3.51,0.76,4.71C387.43,110.9,388.72,111.42,389.66,111.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M479.1,138.25c-0.81,1.12-1.52,2.27-2.18,3.44c-0.59-0.72-1.35-1.51-2.21-2.5 c-0.79-0.89-1.21-1.99-1.34-3.23C475.27,136.76,477.18,137.54,479.1,138.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M331.76,102.18c4.28-0.12,8.41-0.17,12.41-0.17c-1.65,0.87-3.2,1.88-4.51,2.97 c-2.46,1.97-4.38,4.12-6.03,6.28c-0.56-0.53-1.54-1.12-2.64-2.25C329.43,107.44,330.07,104.86,331.76,102.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M409.08,111.88c-0.26,0.08-0.44,0.11-0.75,0.22c-3.09,1.03-6.34,2.99-8.68,5.24 c-2.18,2.04-3.84,4.2-5.29,6.41c-0.59-0.62-1.48-1.37-2.43-2.43c-2.25-2.36-0.84-6.67,1.85-10.71c0.84-1.27,1.8-2.55,2.94-3.78 c2.81,0.54,5.54,1.13,8.16,1.77c0.17,0.42,0.4,0.81,0.72,1.15C406.83,111.06,408.12,111.59,409.08,111.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M424.04,114.17c-1.82,0.98-3.53,2.21-4.91,3.55c-2.18,2.01-3.86,4.18-5.3,6.39 c-0.59-0.64-1.4-1.37-2.41-2.49c-2.27-2.43-0.87-6.73,1.8-10.76c0.02-0.03,0.03-0.05,0.05-0.08 C417.04,111.85,420.62,112.99,424.04,114.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M350.61,102.09c3.82,0.09,7.51,0.23,11.07,0.44c-1.03,0.62-2.01,1.29-2.86,2.01 c-2.46,1.96-4.38,4.09-6.02,6.23c-0.58-0.53-1.57-1.13-2.67-2.29C348.63,106.97,349.13,104.59,350.61,102.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M437.57,119.38c-1.63,1.68-2.95,3.47-4.14,5.26c-0.61-0.64-1.51-1.4-2.49-2.5c-1.31-1.41-1.4-3.45-0.72-5.71 C432.76,117.39,435.2,118.38,437.57,119.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M377.96,103.89c-0.39,0.33-0.76,0.65-1.1,1c-2.18,2.04-3.84,4.21-5.29,6.41c-0.59-0.61-1.48-1.32-2.41-2.36 c-1.35-1.41-1.35-3.56-0.53-5.92C371.83,103.26,374.94,103.55,377.96,103.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M394.83,106.46c-1.51,1.59-2.74,3.25-3.84,4.94c-0.59-0.62-1.46-1.35-2.43-2.43 c-0.93-0.98-1.23-2.3-1.07-3.79C390.01,105.59,392.46,106.01,394.83,106.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M411.46,110.28c-0.37,0.48-0.7,0.98-1.03,1.48c-0.58-0.61-1.34-1.31-2.29-2.36 C409.27,109.69,410.37,109.99,411.46,110.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M224.84,119.14c-0.07,0.18-0.14,0.39-0.18,0.58l-0.02,0c-0.12-0.04-0.24-0.03-0.35-0.04 C224.44,119.5,224.63,119.3,224.84,119.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M224.05,116.66c-1.12,0.78-2.22,1.68-3.3,2.69c-2.61-0.26-5.22-0.51-7.82-0.76 c3.51-2.25,6.22-4.07,7.81-5.13c0.23,0.61,0.53,1.13,0.92,1.59C222.46,115.94,223.27,116.39,224.05,116.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M242.53,114.42c-0.19,0.12-0.36,0.26-0.54,0.4c-3.73,1.04-7.65,2.19-11.79,3.45 c0.3-1.41,0.76-2.95,1.38-4.57c0.4-1.03,0.82-2.08,1.32-3.13c1.48-3.06,3.41-6.03,6.06-8.33c0.02,0,0.02-0.02,0.03-0.02 c0.45-0.26,0.93-0.53,1.4-0.81c-0.58,1.34-1.07,2.71-1.38,4.06c-0.45,1.82-0.47,3.64-0.03,5.15c0.22,0.84,0.58,1.59,1.12,2.18 C240.91,113.7,241.74,114.17,242.53,114.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M258.61,110.58c-2.88,0.67-5.83,1.38-8.94,2.18c0.12-0.4,0.28-0.81,0.44-1.23c0.09-0.28,0.2-0.56,0.33-0.86 c1.76-4.46,4.4-8.97,8.64-11.91c-0.67,1.51-1.24,3.02-1.59,4.56C256.85,106.12,257.21,108.9,258.61,110.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M276.38,107.13c-2.36,0.37-4.76,0.79-7.23,1.26c1.74-4.4,4.34-8.8,8.49-11.65c-0.65,1.51-1.2,3.03-1.52,4.57 C275.63,103.4,275.73,105.48,276.38,107.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M231.91,106.44c-1.37,1.74-2.49,3.53-3.51,5.29c-0.42-0.51-0.96-1.06-1.54-1.69 c-0.09-0.09-0.19-0.19-0.26-0.3C228.03,108.84,229.81,107.73,231.91,106.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M294.91,104.73c-1.59,0.17-3.2,0.34-4.84,0.53c-0.59,0.06-1.18,0.14-1.77,0.22 c1.73-4.04,4.21-8.01,8.04-10.6c-0.65,1.52-1.2,3.06-1.51,4.62C294.43,101.34,294.45,103.18,294.91,104.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M458.6,124.14c-0.26,1.27-0.44,2.6-0.5,3.93c-0.02,0.26-0.03,0.51-0.03,0.78c-0.65-0.31-1.31-0.62-1.97-0.95 C456.77,126.52,457.61,125.24,458.6,124.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M258.52,96.86c-2.69,1.59-5.46,3.96-7.45,6.47c-1.68,2.04-3,4.1-4.18,6.17c-0.44-0.53-0.98-1.07-1.57-1.73 c-1.76-1.76-1.29-5.29,0.36-9.34c2.86-1.59,5.94-3.27,9.24-5.02c0.19,0.7,0.5,1.31,0.93,1.8 C256.73,96.21,257.66,96.66,258.52,96.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M479.83,136.92c-1.43-0.02-2.86-0.03-4.31-0.06h-0.12c-0.68-0.28-1.24-0.58-1.93-0.87 c0.75-4.45,2.04-8.78,4.85-11.77c-0.26,1.35-0.47,2.75-0.51,4.18C477.65,131.38,478.4,134.55,479.83,136.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M313.73,103.08c-2.13,0.14-4.29,0.31-6.5,0.48c1.69-3.96,4.14-7.79,7.88-10.31 c-0.65,1.51-1.18,3.05-1.49,4.59C313.23,99.68,313.26,101.51,313.73,103.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M395.01,105.9c-0.06,0.19-0.11,0.37-0.16,0.56c-0.12-0.03-0.25-0.05-0.39-0.08 C394.64,106.21,394.83,106.05,395.01,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M498.05,124.73c-0.11,0.64-0.22,1.27-0.3,1.91c-0.36,0.36-0.7,0.7-1.03,1.07c-0.42,0.44-0.84,0.89-1.21,1.35 c-0.09,0.09-0.17,0.2-0.25,0.3c-0.08,0.09-0.16,0.17-0.23,0.26C495.78,127.79,496.74,126.11,498.05,124.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M277.06,94.81c-2.69,1.57-5.44,3.93-7.45,6.45c-1.66,2.04-2.97,4.1-4.15,6.19c-0.44-0.54-0.98-1.1-1.59-1.77 c-2.04-2.04-1.18-6.41,1.04-11.21c1.46-3.17,3.41-6.47,6.09-9.17h0.02c1.23-0.59,2.47-1.18,3.75-1.79c-0.48,1-0.9,2.01-1.18,3 c-0.78,2.58-0.54,5.1,0.76,6.61C275.26,94.13,276.21,94.59,277.06,94.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M332.84,102.15c-2.22,0.06-4.49,0.14-6.81,0.23c1.68-4.09,4.15-8.04,7.98-10.6 c-0.64,1.52-1.17,3.06-1.46,4.63C332.12,98.45,332.21,100.49,332.84,102.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M414.34,105.42c-0.42,1.43-0.75,2.88-0.92,4.37c-0.03,0.34-0.06,0.68-0.06,1.03 c-0.92-0.26-1.85-0.53-2.8-0.78C411.56,108.28,412.8,106.71,414.34,105.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M294.01,79.89c-5.17,2.86-8.38,7.86-10.53,12.58c-2.19,4.83-3.03,9.22-0.95,11.31 c0.61,0.67,1.18,1.25,1.63,1.8c1.17-2.08,2.47-4.15,4.14-6.19c1.98-2.52,4.75-4.89,7.43-6.44c-0.86-0.23-1.81-0.71-2.72-1.73 c-1.33-1.54-1.59-4.09-0.83-6.68c0.44-1.6,1.19-3.19,2.04-4.76C294.14,79.82,294.1,79.84,294.01,79.89L294.01,79.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M352.44,102.14c-2.53-0.06-5.12-0.11-7.76-0.12c1.65-4.43,4.15-8.8,8.29-11.54 c-0.62,1.54-1.15,3.09-1.46,4.68C351.01,97.72,351.32,100.29,352.44,102.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M435.06,118.34c-2.39-0.98-4.85-1.94-7.42-2.88c1.17-4,3.03-7.77,6.14-10.37c-0.42,1.45-0.78,2.91-0.92,4.42 C432.5,112.79,433.29,116.18,435.06,118.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M457.22,120.45c-1.96,1.45-3.81,3.39-5.19,5.49c-2.04-0.98-4.1-1.96-6.25-2.94 c0.06-1.59,0.31-3.34,0.73-5.21c1.12-4.85,3.03-9.69,6.75-12.75c-0.4,1.43-0.73,2.89-0.87,4.4c-0.34,3.31,0.47,6.78,2.33,8.99 C455.59,119.47,456.41,120.05,457.22,120.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M373.99,103.49c-3.48-0.36-7.07-0.65-10.81-0.87c0.03-0.12,0.06-0.23,0.11-0.36 c1.62-4.87,4.2-9.84,8.71-12.83c-0.61,1.54-1.1,3.09-1.4,4.66c-0.56,2.97-0.05,5.97,1.55,7.85 C372.78,102.66,373.4,103.15,373.99,103.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M312.69,78.08c-5.18,2.83-8.38,7.84-10.5,12.58c-2.18,4.84-2.98,9.26-0.88,11.39 c0.62,0.68,1.19,1.27,1.65,1.82c1.16-2.09,2.46-4.17,4.11-6.2c1.98-2.52,4.73-4.87,7.42-6.4c-0.86-0.25-1.82-0.74-2.73-1.78 c-1.35-1.57-1.64-4.14-0.91-6.75c0.43-1.6,1.17-3.18,2.01-4.75C312.79,78.02,312.75,78.04,312.69,78.08L312.69,78.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M466.12,117.93c-1.24,5.6-1.02,10.2,1.3,12.6c0.43,0.47,0.81,0.93,1.17,1.4c0.76-1.75,1.64-3.47,2.72-5.16 c1.4-2.31,3.42-4.47,5.55-6.04c-0.79-0.42-1.63-1.01-2.51-2.06c-1.87-2.23-2.71-5.74-2.37-9.07c0.14-1.51,0.45-2.98,0.87-4.42 C469.12,108.22,467.21,113.06,466.12,117.93L466.12,117.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M266.13,87.68c-1.6,1.87-2.91,3.78-4.09,5.68c-0.48-0.54-1.09-1.13-1.83-1.93 c-0.16-0.17-0.31-0.34-0.42-0.54C261.84,89.82,263.96,88.76,266.13,87.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M394.02,103.12c-1.12,0.73-2.24,1.6-3.28,2.61h-0.02c-2.92-0.51-5.92-0.96-9.05-1.37 c0.2-0.96,0.48-1.96,0.82-2.99c1.59-4.87,4.14-9.86,8.66-12.8c-0.61,1.52-1.1,3.08-1.38,4.68c-0.56,2.97,0,6,1.6,7.9 C392.28,102.21,393.18,102.77,394.02,103.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M331.41,76.45c-5.18,2.8-8.34,7.82-10.44,12.58c-2.14,4.86-2.92,9.31-0.8,11.48 c0.63,0.69,1.21,1.29,1.67,1.85c1.16-2.09,2.45-4.17,4.09-6.2c1.98-2.52,4.73-4.86,7.42-6.38c-0.87-0.26-1.84-0.77-2.77-1.82 c-1.38-1.6-1.69-4.19-0.98-6.81c0.43-1.63,1.17-3.22,2.03-4.8C331.54,76.38,331.5,76.41,331.41,76.45L331.41,76.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M485.78,118.27c-1.22,5.61-0.97,10.25,1.38,12.68c0.43,0.48,0.81,0.95,1.18,1.4 c0.75-1.74,1.63-3.46,2.7-5.14c1.4-2.3,3.4-4.45,5.55-6.01c-0.8-0.43-1.64-1.03-2.54-2.1c-1.87-2.26-2.75-5.8-2.43-9.14 c0.13-1.51,0.43-2.97,0.83-4.41C488.74,108.57,486.85,113.4,485.78,118.27L485.78,118.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M413.33,102.57c-2.41,1.57-4.79,3.82-6.45,6.25c-0.05,0.08-0.11,0.14-0.16,0.22c-2.05-0.51-4.14-1-6.3-1.46 c0.05-2.02,0.54-4.37,1.34-6.87c1.57-4.88,4.1-9.87,8.63-12.8c-0.61,1.54-1.1,3.11-1.37,4.71c-0.53,2.99,0.03,6.03,1.65,7.96 C411.59,101.65,412.49,102.23,413.33,102.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M293.81,78.39c-2.95,1.43-6.13,3.84-8.4,6.41c-1.94,2.13-3.47,4.32-4.82,6.5c-0.5-0.56-1.1-1.15-1.85-1.96 c-1.54-1.57-1.18-4.46,0.23-7.76c3.75-1.73,7.65-3.44,11.68-5.13c0.06,0.09,0.16,0.2,0.23,0.3 C291.85,77.82,292.91,78.21,293.81,78.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M512,116.39c-0.44,0.2-0.87,0.4-1.31,0.62c-0.09,0.05-0.2,0.09-0.3,0.16c-0.64,0.31-1.26,0.65-1.87,1 c0,0.02-0.02,0.02-0.02,0.02c-0.64,0.37-1.27,0.75-1.9,1.15c-0.05,0.03-0.09,0.06-0.16,0.09c-0.4,0.26-0.81,0.53-1.2,0.82 c0.08-0.45,0.17-0.93,0.26-1.41c1.04-4.88,2.91-9.72,6.62-12.7c-0.4,1.45-0.7,2.91-0.82,4.43 C511.14,112.54,511.37,114.57,512,116.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M350.26,75.03c-5.2,2.77-8.35,7.78-10.43,12.55c-2.13,4.88-2.86,9.36-0.71,11.56 c0.65,0.71,1.22,1.32,1.7,1.89c1.14-2.09,2.41-4.18,4.05-6.19c1.96-2.52,4.73-4.85,7.43-6.36c-0.87-0.27-1.85-0.79-2.79-1.87 c-1.41-1.63-1.72-4.24-1.02-6.88c0.42-1.62,1.14-3.23,1.97-4.81C350.38,74.96,350.34,74.99,350.26,75.03L350.26,75.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M531.88,106.96c-0.37,1.43-0.67,2.92-0.79,4.45c-0.02,0.26-0.05,0.53-0.05,0.79 c-0.95,0.05-1.91,0.11-2.88,0.17c-0.17,0.02-0.34,0.03-0.5,0.05C528.71,110.28,530.08,108.4,531.88,106.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M421.1,100.25c-1.67,5.28-1.88,9.88,0.39,12.24c0.54,0.61,1.03,1.18,1.46,1.74c0.94-1.95,2-3.88,3.35-5.76 c1.67-2.42,4.02-4.68,6.44-6.21c-0.85-0.36-1.75-0.95-2.67-2.03c-1.63-1.96-2.24-5.05-1.71-8.05c0.26-1.61,0.76-3.18,1.36-4.73 C425.17,90.34,422.64,95.35,421.1,100.25L421.1,100.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M312.45,76.57c-2.97,1.4-6.14,3.79-8.4,6.36c-1.96,2.11-3.47,4.32-4.8,6.51c-0.5-0.58-1.13-1.2-1.88-2.01 c-2.05-2.08-0.84-6.41,1.69-10.9c0.89-1.6,1.94-3.23,3.19-4.8h0.02c2.19-0.86,4.4-1.69,6.65-2.52c-0.76,2.21-0.61,4.35,0.58,5.66 C310.49,75.97,311.55,76.37,312.45,76.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M551.71,108.01c-0.39,1.38-0.67,2.8-0.78,4.28h-0.02c-0.65-0.05-1.34-0.08-2.02-0.11 c-0.23-0.02-0.47-0.02-0.7-0.03C549.13,110.56,550.28,109.13,551.71,108.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M369.19,73.81c-5.2,2.73-8.32,7.76-10.37,12.54c-2.11,4.89-2.81,9.4-0.65,11.64 c0.65,0.71,1.25,1.34,1.72,1.92c1.13-2.1,2.4-4.18,4.04-6.21c1.96-2.52,4.72-4.83,7.42-6.31c-0.89-0.29-1.87-0.82-2.83-1.92 c-1.41-1.65-1.75-4.3-1.06-6.94c0.41-1.65,1.13-3.25,1.96-4.84C369.32,73.74,369.28,73.77,369.19,73.81L369.19,73.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M440.52,100c-1.65,5.29-1.85,9.92,0.44,12.32c0.56,0.63,1.04,1.21,1.49,1.78c0.93-1.95,1.98-3.89,3.32-5.77 c1.67-2.42,4.04-4.65,6.45-6.17c-0.86-0.37-1.78-0.97-2.71-2.08c-1.66-1.99-2.26-5.09-1.74-8.11c0.25-1.6,0.72-3.18,1.31-4.72 C444.56,90.1,442.05,95.09,440.52,100L440.52,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M329.17,63.08c-5.42,2.59-9.04,7.29-11.46,11.68c-2.51,4.5-3.69,8.84-1.62,10.96 c0.77,0.83,1.4,1.47,1.91,2.05c1.33-2.19,2.83-4.4,4.77-6.52c2.26-2.56,5.43-4.94,8.4-6.32c-0.9-0.21-1.97-0.65-2.97-1.75 c-1.23-1.38-1.39-3.6-0.57-5.9c0.55-1.58,1.46-3.14,2.49-4.69C329.83,62.75,329.57,62.89,329.17,63.08L329.17,63.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M388.23,72.8c-5.21,2.69-8.32,7.71-10.35,12.51c-2.08,4.9-2.77,9.42-0.57,11.71 c0.66,0.73,1.26,1.37,1.74,1.96c1.13-2.1,2.39-4.2,4.03-6.22c1.95-2.51,4.71-4.81,7.41-6.27c-0.9-0.29-1.89-0.84-2.86-1.96 c-1.42-1.68-1.8-4.35-1.12-7.01c0.39-1.63,1.1-3.24,1.92-4.82C388.34,72.74,388.31,72.77,388.23,72.8L388.23,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M460.01,99.98c-1.63,5.3-1.8,9.95,0.51,12.39c0.56,0.63,1.05,1.22,1.49,1.79c0.93-1.95,1.97-3.88,3.31-5.75 c1.66-2.42,4.02-4.65,6.44-6.14c-0.87-0.38-1.78-1-2.73-2.12c-1.67-2.02-2.31-5.14-1.82-8.18c0.25-1.61,0.73-3.19,1.31-4.73 C464,90.04,461.52,95.05,460.01,99.98L460.01,99.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M479.57,100.16c-1.61,5.32-1.75,9.99,0.57,12.46c0.56,0.65,1.06,1.25,1.51,1.82 c0.91-1.95,1.96-3.88,3.3-5.74c1.63-2.41,4-4.62,6.41-6.1c-0.86-0.4-1.78-1.02-2.74-2.16c-1.68-2.05-2.33-5.21-1.85-8.25 c0.24-1.62,0.71-3.2,1.29-4.75C483.53,90.22,481.07,95.23,479.57,100.16L479.57,100.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M407.34,71.99c-5.21,2.65-8.32,7.68-10.32,12.48c-2.07,4.92-2.72,9.47-0.5,11.79 c0.66,0.74,1.27,1.39,1.76,1.99c1.12-2.1,2.37-4.19,4.01-6.2c1.94-2.51,4.7-4.8,7.42-6.23c-0.91-0.31-1.9-0.87-2.89-2.01 c-1.45-1.71-1.84-4.4-1.19-7.07c0.39-1.65,1.11-3.26,1.92-4.85C407.46,71.93,407.42,71.96,407.34,71.99L407.34,71.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M347.91,61.53c-5.43,2.55-9.04,7.23-11.44,11.64c-2.49,4.51-3.63,8.89-1.54,11.04 c0.77,0.84,1.42,1.49,1.94,2.07c1.32-2.2,2.81-4.39,4.75-6.51c2.25-2.54,5.43-4.92,8.4-6.28c-0.92-0.22-2-0.67-3.02-1.79 c-1.24-1.4-1.41-3.66-0.6-5.97c0.53-1.57,1.44-3.14,2.46-4.67C348.54,61.21,348.29,61.35,347.91,61.53L347.91,61.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M298.68,73.14c-0.79,0.98-1.52,1.99-2.22,2.99c-0.4-0.4-0.93-0.86-1.55-1.46 C296.14,74.16,297.42,73.65,298.68,73.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M499.2,100.58c-1.59,5.32-1.71,10,0.62,12.53c0.58,0.65,1.08,1.26,1.53,1.84c0.91-1.94,1.94-3.88,3.28-5.74 c1.64-2.4,3.99-4.59,6.41-6.05c-0.86-0.41-1.79-1.05-2.76-2.2c-1.69-2.08-2.35-5.25-1.9-8.3c0.23-1.64,0.7-3.23,1.28-4.78 C503.12,90.61,500.67,95.62,499.2,100.58L499.2,100.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M426.54,71.41c-5.23,2.61-8.29,7.63-10.28,12.44c-2.04,4.92-2.68,9.5-0.44,11.87 c0.67,0.75,1.28,1.42,1.77,2.02c1.11-2.1,2.35-4.19,3.98-6.2c1.94-2.5,4.69-4.77,7.41-6.2c-0.91-0.32-1.91-0.91-2.9-2.05 c-1.47-1.74-1.87-4.45-1.23-7.13c0.38-1.66,1.08-3.28,1.9-4.86C426.66,71.34,426.62,71.37,426.54,71.41L426.54,71.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M366.73,60.17c-5.43,2.51-9.04,7.2-11.42,11.61c-2.47,4.52-3.57,8.91-1.45,11.1 c0.79,0.87,1.44,1.53,1.96,2.12c1.31-2.2,2.8-4.4,4.72-6.52c2.24-2.54,5.41-4.89,8.4-6.23c-0.92-0.24-2.01-0.69-3.03-1.84 c-1.27-1.43-1.47-3.7-0.68-6.02c0.52-1.58,1.43-3.15,2.44-4.69C367.36,59.86,367.11,59.99,366.73,60.17L366.73,60.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M530.78,103.95c-2.41,1.43-4.76,3.61-6.41,6c-0.73,1.03-1.37,2.07-1.94,3.13c-0.34,0.06-0.68,0.12-1.03,0.2 c-0.08,0.02-0.16,0.03-0.23,0.05c-0.56,0.12-1.12,0.25-1.66,0.39c-2.3-2.58-2.18-7.25-0.62-12.52c1.46-4.94,3.89-9.94,8.43-12.63 c-0.58,1.54-1.03,3.14-1.24,4.76c-0.45,3.06,0.23,6.27,1.93,8.38C528.98,102.88,529.91,103.54,530.78,103.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M326.76,63.13c-2.24,1.26-4.45,2.89-6.19,4.62c-2.22,2.13-3.96,4.34-5.47,6.56 c-0.53-0.54-1.27-1.13-2.18-2.07c-0.98-0.98-1.1-2.47-0.64-4.23C316.99,66.31,321.81,64.68,326.76,63.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M445.82,71.05c-5.23,2.55-8.28,7.58-10.25,12.41c-2.02,4.93-2.64,9.52-0.38,11.93 c0.68,0.77,1.31,1.44,1.8,2.05c1.11-2.1,2.35-4.19,3.97-6.19c1.93-2.49,4.69-4.75,7.41-6.15c-0.92-0.34-1.94-0.93-2.94-2.1 c-1.48-1.77-1.9-4.49-1.27-7.19c0.38-1.66,1.07-3.28,1.87-4.87C445.94,70.98,445.9,71.01,445.82,71.05L445.82,71.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M550.57,104.98c-2.44,1.41-4.79,3.58-6.41,5.95c-0.25,0.36-0.5,0.72-0.72,1.07 c-0.19-0.02-0.39-0.02-0.59-0.02c-1.62-0.03-3.27-0.03-4.96-0.02c-0.73-2.63-0.34-6.11,0.75-9.89c1.43-4.96,3.86-9.95,8.4-12.59 c-0.56,1.55-1.03,3.14-1.23,4.77c-0.45,3.08,0.25,6.3,1.97,8.43C548.75,103.88,549.7,104.55,550.57,104.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M385.64,59.03c-5.45,2.46-9.02,7.14-11.39,11.56c-2.45,4.52-3.54,8.94-1.4,11.18 c0.8,0.88,1.45,1.54,1.98,2.14c1.31-2.2,2.78-4.4,4.71-6.5c2.24-2.54,5.42-4.87,8.41-6.18c-0.93-0.25-2.02-0.73-3.06-1.89 c-1.27-1.45-1.5-3.74-0.72-6.07c0.52-1.58,1.42-3.14,2.42-4.68C386.29,58.73,386.03,58.86,385.64,59.03L385.64,59.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M568.76,107.02c-0.06,0.16-0.12,0.3-0.19,0.45c-1.74,1.29-3.34,2.94-4.57,4.7 c-0.31,0.44-0.61,0.87-0.89,1.31c-1.69-0.23-3.51-0.45-5.44-0.64c-0.64-2.61-0.26-5.97,0.78-9.62c0.37-1.29,0.81-2.58,1.34-3.82 C562.65,101.78,565.67,104.34,568.76,107.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M465.17,70.91c-5.23,2.51-8.26,7.53-10.22,12.37c-2,4.94-2.61,9.56-0.32,12c0.69,0.77,1.32,1.46,1.81,2.08 c1.1-2.1,2.32-4.19,3.94-6.18c1.93-2.49,4.67-4.72,7.39-6.1c-0.91-0.34-1.93-0.95-2.94-2.14c-1.5-1.79-1.94-4.54-1.32-7.24 c0.36-1.67,1.05-3.29,1.85-4.88C465.3,70.84,465.26,70.87,465.17,70.91L465.17,70.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M348.66,60.08c-0.25,0.09-0.4,0.14-0.72,0.26c-3.05,1.24-6.3,3.42-8.66,5.77c-2.21,2.13-3.95,4.35-5.46,6.58 c-0.54-0.54-1.29-1.15-2.21-2.11c-1.9-1.91-0.65-5.68,1.79-9.45c3.84-1.13,7.76-2.21,11.71-3.2c0.09,0.16,0.2,0.31,0.33,0.45 C346.53,59.5,347.75,59.88,348.66,60.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M404.65,58.09c-5.46,2.42-9.03,7.09-11.37,11.52c-2.43,4.53-3.47,8.97-1.31,11.25 c0.81,0.89,1.47,1.57,2,2.18c1.3-2.2,2.76-4.4,4.68-6.5c2.24-2.54,5.42-4.85,8.4-6.13c-0.94-0.26-2.04-0.75-3.1-1.94 c-1.29-1.47-1.52-3.79-0.75-6.12c0.51-1.59,1.4-3.16,2.4-4.7C405.29,57.79,405.04,57.92,404.65,58.09L404.65,58.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M484.61,71c-5.24,2.46-8.28,7.48-10.21,12.31c-1.98,4.95-2.54,9.58-0.22,12.07 c0.69,0.79,1.32,1.48,1.82,2.11c1.1-2.1,2.32-4.19,3.93-6.17c1.93-2.48,4.67-4.69,7.39-6.05c-0.91-0.35-1.94-0.98-2.97-2.18 c-1.51-1.83-1.96-4.59-1.36-7.3c0.36-1.68,1.04-3.3,1.82-4.9C484.74,70.92,484.7,70.95,484.61,71L484.61,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M367.48,58.73c-0.25,0.09-0.4,0.14-0.73,0.26c-3.03,1.21-6.3,3.36-8.66,5.71c-2.21,2.11-3.93,4.34-5.43,6.56 c-0.56-0.56-1.31-1.18-2.22-2.16c-2.07-2.08-0.53-6.3,2.29-10.39c0.73-1.07,1.55-2.16,2.47-3.22c2.71-0.61,5.41-1.17,8.15-1.69 c-0.14,1.24,0.14,2.36,0.89,3.17C365.33,58.13,366.57,58.52,367.48,58.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M423.75,57.38c-5.47,2.37-9.01,7.04-11.34,11.47c-2.43,4.53-3.46,8.99-1.27,11.3 c0.8,0.89,1.52,1.58,2.06,2.2c1.28-2.19,2.73-4.38,4.63-6.46c2.24-2.52,5.42-4.81,8.42-6.08c-0.95-0.27-2.07-0.77-3.14-1.98 c-1.31-1.51-1.55-3.84-0.79-6.18c0.5-1.6,1.38-3.16,2.37-4.7C424.39,57.09,424.14,57.21,423.75,57.38L423.75,57.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M504.11,71.31c-5.25,2.41-8.28,7.42-10.18,12.25c-1.96,4.95-2.52,9.6-0.19,12.13 c0.7,0.8,1.33,1.51,1.86,2.15c1.08-2.1,2.3-4.18,3.9-6.16c1.92-2.47,4.67-4.66,7.39-5.99c-0.92-0.37-1.94-1-2.98-2.23 c-1.53-1.85-2.02-4.64-1.41-7.36c0.35-1.67,1.02-3.3,1.81-4.89C504.23,71.25,504.19,71.27,504.11,71.31L504.11,71.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M526.53,86.35c-2.72,1.31-5.46,3.47-7.39,5.92c-1.59,1.99-2.81,4.06-3.89,6.16 c-0.51-0.65-1.17-1.37-1.87-2.18c-2.35-2.57-1.82-7.23,0.14-12.19c1.66-4.29,4.23-8.69,8.46-11.29c0.39,0.2,0.78,0.4,1.15,0.62 c-0.45,1.07-0.81,2.16-1.04,3.27c-0.61,2.72-0.09,5.52,1.43,7.4C524.58,85.31,525.62,85.98,526.53,86.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M386.4,57.57c-0.26,0.09-0.42,0.12-0.73,0.25c-3.05,1.2-6.33,3.33-8.68,5.66c-2.21,2.1-3.92,4.32-5.41,6.55 c-0.56-0.56-1.32-1.2-2.25-2.19c-2.1-2.13-0.56-6.36,2.21-10.43c1.34-1.99,3-4.04,5.05-5.86c0.02,0,0.02,0,0.02,0 c2.02-0.3,4.06-0.58,6.09-0.81c-0.81,1.94-0.72,3.81,0.4,5.02C384.22,56.94,385.47,57.36,386.4,57.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M442.92,56.89c-5.49,2.32-9.02,6.98-11.32,11.41c-2.39,4.54-3.4,9.01-1.19,11.37 c0.84,0.93,1.52,1.64,2.05,2.27c1.29-2.21,2.74-4.4,4.66-6.49c2.22-2.52,5.38-4.78,8.38-6.02c-0.95-0.29-2.06-0.82-3.15-2.04 c-1.32-1.53-1.56-3.87-0.82-6.23c0.48-1.6,1.35-3.17,2.34-4.7C443.57,56.6,443.31,56.72,442.92,56.89L442.92,56.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M545.33,87.71c-2.43,1.31-4.76,3.23-6.45,5.43c-1.62,1.96-2.81,4.03-3.89,6.13 c-0.53-0.67-1.17-1.4-1.88-2.22c-2.36-2.6-1.83-7.28,0.09-12.24c0.56-1.43,1.2-2.88,1.99-4.26c3.2,2.08,6.03,4.09,8.55,5.97 C544.26,86.88,544.79,87.29,545.33,87.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M462.19,56.62c-5.49,2.27-9,6.92-11.3,11.35c-2.37,4.54-3.38,9.03-1.14,11.43c0.81,0.92,1.54,1.64,2.1,2.27 c1.27-2.19,2.71-4.37,4.61-6.43c2.22-2.5,5.39-4.74,8.41-5.95c-0.95-0.3-2.07-0.84-3.18-2.09c-1.32-1.55-1.62-3.93-0.88-6.29 c0.48-1.6,1.35-3.17,2.33-4.7C462.83,56.34,462.58,56.46,462.19,56.62L462.19,56.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M405.38,56.64c-0.25,0.09-0.42,0.12-0.73,0.23c-3.05,1.18-6.31,3.3-8.66,5.61c-2.21,2.1-3.92,4.31-5.4,6.55 c-0.56-0.59-1.34-1.24-2.29-2.25c-2.11-2.16-0.62-6.42,2.16-10.49c1.6-2.38,3.67-4.85,6.3-6.9c1.71-0.12,3.44-0.22,5.16-0.3 c-0.09,0.17-0.17,0.34-0.23,0.51c-0.87,1.99-0.78,3.92,0.37,5.16C403.21,55.97,404.43,56.41,405.38,56.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M556.74,96.85c-0.73,1.14-1.37,2.3-1.96,3.48c-0.53-0.67-1.18-1.41-1.9-2.25c-1.27-1.4-1.73-3.39-1.59-5.68 c0.31,0.23,0.62,0.5,0.93,0.75v0.02C553.68,94.33,555.19,95.56,556.74,96.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M352.69,56.07c-0.82,0.9-1.59,1.82-2.29,2.74c-0.48-0.4-1.27-0.87-2.16-1.68 C349.72,56.75,351.2,56.39,352.69,56.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M484.27,69.36c-3.02,1.18-6.19,3.39-8.4,5.89c-1.9,2.04-3.33,4.21-4.59,6.42c-0.56-0.65-1.29-1.38-2.11-2.32 c-2.27-2.44-1.29-6.95,1.07-11.49c2.16-4.21,5.43-8.61,10.48-10.93c0.37,0.09,0.73,0.2,1.1,0.3c-0.7,1.2-1.31,2.43-1.68,3.67 c-0.73,2.35-0.42,4.74,0.92,6.31C482.18,68.49,483.31,69.03,484.27,69.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M424.46,55.93c-0.23,0.08-0.4,0.12-0.7,0.23c-3.06,1.13-6.33,3.23-8.69,5.55c-2.19,2.07-3.9,4.29-5.38,6.51 c-0.58-0.59-1.35-1.26-2.32-2.29c-2.13-2.21-0.65-6.47,2.1-10.56c1.51-2.24,3.42-4.57,5.85-6.55h0.98 c1.46,0.02,2.92,0.05,4.35,0.08c-0.78,1.94-0.65,3.86,0.48,5.08C422.27,55.23,423.53,55.69,424.46,55.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M374.38,51.88c-2.04,1.79-3.7,3.67-5.16,5.58c-0.56-0.5-1.52-1.03-2.58-2.1c-0.56-0.54-0.81-1.24-0.82-2.04 C368.64,52.8,371.5,52.32,374.38,51.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M503.76,69.67c-2.99,1.13-6.17,3.33-8.38,5.81c-1.9,2.05-3.34,4.23-4.6,6.44c-0.56-0.68-1.24-1.41-2.11-2.39 c-2.29-2.47-1.32-7,1.04-11.54c1.21-2.39,2.8-4.84,4.87-6.92c1.62,0.54,3.19,1.09,4.71,1.66c-0.2,1.8,0.22,3.51,1.27,4.74 C501.66,68.77,502.81,69.34,503.76,69.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M443.65,55.43c-0.25,0.08-0.42,0.12-0.73,0.23c-3.08,1.12-6.34,3.17-8.68,5.47c-2.19,2.08-3.9,4.28-5.35,6.5 c-0.58-0.59-1.37-1.27-2.35-2.33c-2.18-2.25-0.7-6.51,2.02-10.59c1.18-1.77,2.64-3.59,4.38-5.26c2.16,0.14,4.29,0.3,6.37,0.48 c-0.19,1.35,0.11,2.61,0.95,3.51C441.44,54.71,442.71,55.18,443.65,55.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M520.08,71.8c-1.91,1.14-3.72,2.58-5.13,4.17c-1.88,2.04-3.33,4.2-4.57,6.37c-0.56-0.67-1.31-1.43-2.15-2.39 c-2.3-2.52-1.37-7.04,0.95-11.57c0.23-0.47,0.48-0.93,0.75-1.4C513.54,68.55,516.93,70.17,520.08,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M394.79,49.52c-0.22,0.16-0.42,0.31-0.61,0.48c-2.47,2.01-4.42,4.17-6.06,6.33c-0.56-0.5-1.54-1.06-2.6-2.16 c-0.93-0.9-1.04-2.21-0.59-3.7C388.2,50.08,391.5,49.77,394.79,49.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M462.9,55.18c-0.25,0.06-0.42,0.11-0.73,0.2c-3.08,1.09-6.33,3.13-8.68,5.41c-2.18,2.05-3.86,4.21-5.32,6.42 c-0.58-0.59-1.45-1.29-2.38-2.32c-2.21-2.29-0.76-6.56,1.96-10.63c0.7-1.06,1.49-2.13,2.39-3.17c3.02,0.37,5.95,0.81,8.82,1.27 c0.14,0.28,0.33,0.54,0.54,0.78C460.67,54.42,461.95,54.9,462.9,55.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M532.68,78.94c-1.01,1.34-1.87,2.71-2.66,4.09c-0.58-0.68-1.32-1.45-2.16-2.43 c-1.2-1.32-1.54-3.17-1.24-5.29C528.76,76.53,530.78,77.74,532.68,78.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M413.51,48.82c-0.12,0.08-0.23,0.19-0.36,0.28c-2.46,1.99-4.38,4.14-6.03,6.3 c-0.58-0.51-1.54-1.09-2.63-2.19c-1.04-1.03-1.09-2.53-0.48-4.21c2.97-0.11,5.95-0.17,8.94-0.17H413.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M478.89,56.47c-2.24,1.09-4.4,2.57-6.08,4.21c-2.18,2.04-3.84,4.2-5.3,6.41c-0.58-0.61-1.46-1.34-2.41-2.36 c-2.21-2.33-0.78-6.62,1.93-10.68c0.05-0.06,0.09-0.14,0.14-0.2C471.25,54.64,475.15,55.52,478.89,56.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M431.15,49.35c-1.94,1.71-3.55,3.53-4.94,5.36c-0.56-0.53-1.54-1.12-2.64-2.25 c-0.89-0.89-1.06-2.11-0.75-3.48C425.64,49.05,428.43,49.18,431.15,49.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M492.64,60.44c-0.14,0.11-0.28,0.23-0.4,0.36c-2.18,2.04-3.84,4.2-5.29,6.41c-0.59-0.62-1.48-1.37-2.43-2.43 c-1.54-1.62-1.37-4.14-0.23-6.87C487.17,58.71,489.95,59.55,492.64,60.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M507.5,65.96c-0.39,0.53-0.75,1.07-1.1,1.6c-0.59-0.64-1.4-1.37-2.41-2.49c-0.22-0.23-0.4-0.5-0.56-0.76 C504.83,64.85,506.18,65.4,507.5,65.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M448.25,50.86c-1.07,1.1-2.02,2.22-2.88,3.36c-0.58-0.53-1.57-1.13-2.67-2.29c-0.48-0.5-0.76-1.09-0.87-1.76 C444,50.38,446.15,50.61,448.25,50.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M465.04,53.42c-0.31,0.44-0.61,0.89-0.9,1.32c-0.48-0.5-1.15-1.06-1.9-1.82 C463.19,53.08,464.11,53.25,465.04,53.42z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M579.96,116.88c0,0-0.87-0.28-2.52-0.7c-0.39-0.09-0.84-0.22-1.32-0.33c-0.53-0.12-1.1-0.26-1.74-0.4 c-4.12-0.9-10.4-2.05-18.39-2.78c-0.93-0.08-1.9-0.16-2.88-0.23c-0.08,0-0.16-0.02-0.22-0.02c-0.65-0.05-1.31-0.09-1.97-0.12 c-0.65-0.05-1.34-0.08-2.02-0.11c-0.28-0.02-0.58-0.03-0.86-0.05l-19.16-16.17c-29.31-19.95-67.21-30.32-112.76-30.8 c-1.09-0.02-2.11-0.02-3.17-0.02h-0.17c-29.85,0-59.36,6.37-85.61,15c-19.67,1.29-40.38,3.89-61.99,7.99 c36.18-17.99,91-39.37,147.77-39.32c1.12,0,2.24,0,3.34,0.02c69.47,0.75,108.14,23.29,127.45,37.67c2.41,1.8,5.29,4.06,8.49,6.64 v0.02c6.7,5.41,14.83,12.3,23.17,19.67C576.91,114.17,578.43,115.52,579.96,116.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.8894,
    y1: 264.7719,
    x2: 221.3339,
    y2: 211.0023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4EDE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4874,
    style: {
      stopColor: "#5D8898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M238.11,201.03c0,0-61.88-12.4-53.61,6.43s36.65,37.95,64.21,46.59c27.56,8.64,62.35,12.54,70.89,2.45 c13.1-15.47,0.38-32.57-30.11-42.05C259.73,205.19,249.41,203.9,238.11,201.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 532.3692,
    y1: 235.2286,
    x2: 602.2047,
    y2: 245.7816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4EDE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4874,
    style: {
      stopColor: "#5D8898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M628.75,228.95c-1.37,4.4-5.19,8.19-10.49,11.02c-5.95,3.19-33.91,16.53-51.59,24.94 c-10.08,4.79-21.85,4.63-31.72-0.54c-1.46-0.78-3-1.6-4.59-2.5c4-15.61,27.92-43.24,44.39-50.8 C581.33,211.61,617.43,217.3,628.75,228.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 634.1282,
    y1: 192.5579,
    x2: 575.301,
    y2: 220.4108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4874,
    style: {
      stopColor: "#5D8898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00516D"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M628.75,228.94c-11.91-12.25-51.2-17.91-54.78-17.91c-1.19,0-2.08-0.55-2.74-1.29 c-1.45-1.62-1.69-3.99-0.84-5.99c12.62-29.58,53.19-37.22,54.14-37.49c0.02,0,0.02,0,0.02,0c2.25,6.31-0.17,7-1.55,7.59 c-6.13,2.57-34.63,15.77-43.86,30.01c0,0,44.89,7.06,48.81,15.5C629.51,222.75,629.7,225.99,628.75,228.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.1447,
    y1: 312.4304,
    x2: 273.1041,
    y2: 284.663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M253.06,298.03c-11.29,2.25-24.27,4.49-37.95,6.2c-11.75,1.46-24.04,2.52-36.17,2.83 c1.66-2.95,2.86-6.45,2.49-10.15c-0.03-0.33-0.08-0.64-0.14-0.95c6.65-0.22,14.02-0.65,21.92-1.41 c11.07-1.07,23.17-2.78,35.82-5.43C243.28,292.35,247.82,295.32,253.06,298.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.3161,
    y1: 290.5268,
    x2: 268.2755,
    y2: 262.7593
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M228.12,279.66c-9.02,1.65-18.83,3.22-29.03,4.48c-9.06,1.13-18.41,2.02-27.78,2.52 c-0.36-0.09-0.59-0.12-0.65-0.12c0.25,0,2.47-5.74,3.45-11.07c4.17-0.23,8.54-0.58,13.09-1.01c9.76-0.95,20.34-2.36,31.38-4.52 C221.85,273.43,225.07,276.73,228.12,279.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.5579,
    y1: 268.9424,
    x2: 263.5173,
    y2: 241.1749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M209.59,260.03c-8.32,1.49-17.26,2.89-26.53,4.04c-2.85,0.36-5.71,0.68-8.6,0.98 c-0.25-3.96-0.86-7.54-1.74-10.82c8.89-0.9,18.39-2.21,28.31-4.09C203.82,253.43,206.69,256.76,209.59,260.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.6434,
    y1: 246.6492,
    x2: 258.6029,
    y2: 218.8818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M192.7,240.09c-7.62,1.35-15.77,2.64-24.19,3.72c-0.81-1.48-1.68-2.86-2.61-4.18 c-1.54-2.21-3.13-4.17-4.71-5.95c7.46-0.86,15.33-2.01,23.48-3.54C187.06,233.16,189.76,236.53,192.7,240.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.7143,
    y1: 224.2897,
    x2: 253.6738,
    y2: 196.5223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M176.81,220.01c-7.81,1.38-16.17,2.69-24.81,3.78c-0.53-0.61-1.01-1.21-1.43-1.82 c-1.96-2.75-2.92-5.46-2.19-8.77c6.69-0.82,13.65-1.88,20.83-3.25c2.25,2.57,3.95,4.94,5.08,6.59 C174.79,217.25,175.64,218.45,176.81,220.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st49"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.86,
    y1: 113.4596,
    x2: 33.1772,
    y2: 79.7172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M105.82,132.25c2.74-2.8,6.3-5.57,9.95-7.62c-8.91-10.62-20.74-23.98-34.21-37.3 C68.28,74.18,53.37,61.07,38.03,50.59c-0.37,2.32-1.03,4.59-1.88,6.79c-0.56,1.48-0.95,2.94-1.18,4.35 c8.27,6.08,19.3,14.82,31.25,26.01C79.11,99.8,93.07,114.73,105.82,132.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.8729,
    y1: 139.8958,
    x2: 25.1901,
    y2: 106.1534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M54.17,113.13c13.92,9.98,29.2,22.51,43.74,37.63c0.7-4.12,1.77-8.23,3.37-12.17 c0.14-0.33,0.3-0.67,0.48-1.03c-9.19-8.21-20.27-17.58-32.45-26.82c-11.8-8.97-24.61-17.8-37.67-25.27 c-0.68,4.1-0.78,8.3-0.45,12.5C38.07,102.14,45.88,107.17,54.17,113.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.9192,
    y1: 258.8975,
    x2: -10.7636,
    y2: 225.155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M127.48,197.74c-7.85,2.24-9.89,4.01-16.56,7.37c-2.16,1.09-6.05,1.57-8.58-0.26 c-3.72,4.88-5.85,7.67-5.88,7.73c-15.92,19.81-33.63,36.03-49.6,48.62c-14.48,11.41-27.52,19.82-36.49,25.17 c-0.54,1.29-1.03,2.99-1.41,5.35c-0.44,2.66-0.78,5.54-1.06,8.29c18.78-9.56,37.58-23.23,54.22-37.1 c30.44-25.39,52.69-51.64,55.26-54.56c0.16-0.17,10.15-10.62,10.15-10.62L127.48,197.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.8771,
    y1: 239.1775,
    x2: -4.8056,
    y2: 205.4351
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M101.6,204.21c-1.13-1.17-1.85-2.99-1.74-5.66c0.03-0.68,0-1.49-0.06-2.43c-0.12-1.57-0.36-3.48-0.65-5.66 c-18.56,14.43-37.78,25.53-54.84,33.83c-18.1,8.83-33.74,14.52-43.61,17.71v0.02c-0.84,4.14-0.86,7.95-0.39,11.33 c19.67-5.46,40.07-14.49,58.54-24.15C75.22,220.67,90.08,211.66,101.6,204.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.141,
    y1: 198.586,
    x2: 7.4582,
    y2: 164.8435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4369,
    style: {
      stopColor: "#61818C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003E4F"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M98.59,186.45c-0.44-3.17-0.9-6.73-1.24-10.54c-0.09-0.96-0.17-1.94-0.23-2.94v-0.02 c-0.03-0.31-0.05-0.61-0.06-0.92c-0.17-2.66-0.26-5.41-0.23-8.21c0-2.18,0.09-4.37,0.28-6.59c-9.59-6.31-20.77-13.29-32.81-20.03 c-8.68-4.87-17.79-9.59-27.07-13.87c2.05,5.61,4.32,10.79,6.28,15.22c2.01,1,4.04,2.05,6.13,3.14 c11.89,6.23,24.85,13.92,37.83,23.2c-15.55,1.49-30.3,1.69-43.49,1.2c-0.23-0.02-0.47-0.02-0.7-0.03 c-2.58,2.77-5.27,4.63-6.06,5.66c-1.4,1.79-1.94,3.41-2.22,4.91c6.55,0.39,13.08,0.59,19.48,0.65c13,0.12,25.45-0.31,36.44-0.96 c-18.5,9.8-36.91,16.9-53.24,22.02c-6.25,1.96-12.19,3.64-17.71,5.05c-2.67,4.23-5.46,8.75-8.05,13.28 c13.34-2.95,26.74-6.95,39.4-11.3C69.37,199.16,85.9,192.19,98.59,186.45z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.3851,
    y1: -0.1977,
    x2: 400.0652,
    y2: 87.1798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005181347,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#172029",
      stopOpacity: 0
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M577.44,116.17c-0.39-0.09-0.84-0.22-1.32-0.33c-0.53-0.12-1.1-0.26-1.74-0.4c-4.12-0.9-10.4-2.05-18.39-2.78 c-0.93-0.08-1.9-0.16-2.88-0.23c-0.08,0-0.16-0.02-0.22-0.02c-0.65-0.05-1.31-0.09-1.97-0.12c-0.65-0.05-1.34-0.08-2.02-0.11 c-0.65-0.03-1.31-0.06-1.99-0.09c-0.73-0.02-1.49-0.05-2.25-0.06c-0.59-0.02-1.18-0.03-1.79-0.03c-4.57-0.08-9.48,0.03-14.69,0.37 c-0.33,0.03-0.65,0.05-0.96,0.08c-0.33,0.02-0.64,0.05-0.96,0.09c-0.26,0.02-0.53,0.05-0.79,0.09c-0.47,0.05-0.93,0.11-1.4,0.19 c-0.37,0.05-0.75,0.11-1.1,0.19c-0.14,0.02-0.26,0.03-0.4,0.06c-0.37,0.06-0.76,0.14-1.13,0.22c-0.08,0.02-0.16,0.03-0.23,0.05 c-0.58,0.12-1.17,0.26-1.73,0.4c-0.06,0.02-0.11,0.03-0.17,0.05c0,0-0.03,0.02-0.08,0.03c-0.28,0.08-0.56,0.14-0.82,0.22 c-0.5,0.14-0.98,0.3-1.46,0.45c-0.73,0.23-1.45,0.48-2.15,0.75c-0.05,0.02-0.09,0.03-0.14,0.05c-0.02,0-0.03,0.02-0.05,0.02 c-0.68,0.28-1.35,0.54-2.01,0.84c-0.64,0.28-1.26,0.58-1.88,0.89c-0.09,0.05-0.2,0.09-0.3,0.16c-0.64,0.31-1.26,0.65-1.87,1 c0,0.02-0.02,0.02-0.02,0.02c-0.64,0.37-1.27,0.75-1.9,1.15c-0.05,0.03-0.09,0.06-0.16,0.09c-0.59,0.39-1.17,0.78-1.73,1.18 c-0.09,0.06-0.19,0.12-0.26,0.19c-0.23,0.19-0.48,0.36-0.72,0.53c-0.25,0.19-0.48,0.36-0.72,0.54c-0.45,0.36-0.92,0.73-1.35,1.1 c-1.34,1.12-2.61,2.3-3.84,3.56c-0.03,0.03-0.08,0.08-0.09,0.11c-0.36,0.36-0.7,0.7-1.03,1.07c-0.42,0.44-0.84,0.89-1.21,1.35 c-0.09,0.09-0.17,0.2-0.25,0.3c-0.47,0.5-0.89,1.03-1.31,1.54c-0.51,0.64-1.03,1.29-1.52,1.96c-0.51,0.65-1,1.34-1.48,2.02 c-0.48,0.65-0.93,1.32-1.38,1.99c-0.08,0.12-0.16,0.23-0.23,0.36c-0.78,1.2-1.54,2.43-2.29,3.68l-0.02-0.02 c-41.06-11.8-69-50.18-196.96-35.64c-25.2,2.86-50.43,8.55-100.66,26.87c17.07-8.58,32.22-19.44,32.84-19.64 c1.06-0.36,92.98-63.75,190.7-63.67c1.12,0,2.24,0,3.34,0.02c69.47,0.75,108.14,23.29,127.45,37.67c2.41,1.8,5.29,4.06,8.49,6.64 v0.02c6.7,5.41,14.83,12.3,23.17,19.67L577.44,116.17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishResult1);
export default __webpack_public_path__ + "static/media/fish-result-1.dc09fcd0edac149d703c57839a29af6c.svg";
export { ForwardRef as ReactComponent };